<template>
  <div v-if="!$store.getters.getMobilePhoneActive">
    <div class="text-xs-center">
      <v-dialog
        v-model="downloadAppDialog"
        width="600"
        persistent
        no-click-animation
      >
        <v-card>
          <v-card-title
            class="headline grey lighten-2"
          >
            {{appTitle}}
          </v-card-title>

          <v-flex xs12 style="margin-bottom: 1em;">
            <v-layout row>
              <v-flex xs7>
                <v-card-text>
                  {{appDescription}}
                </v-card-text>
                <v-flex xs12>
                  <v-layout row justify-space-around>
                    <a :href="$store.getters.getCustomerPreferences.ios_app_url"
                       target="_blank"
                       rel="noopener noreferrer">
                      <v-img style="width: 120px; margin-top: 2px;" :src="require('../../assets/Download_on_the_App_Store.png')"/>
                    </a>
                    <a :href="$store.getters.getCustomerPreferences.android_app_url"
                       target="_blank"
                       rel="noopener noreferrer">
                      <v-img width="150" :src="require('../../assets/Download_on_the_Play_Store.png')"></v-img>
                    </a>
                  </v-layout>
                </v-flex>
              </v-flex>
              <v-flex xs5 style="padding-left: 3em;">
                <v-img style="width: 12em;" contain :src="mobileImage()"></v-img>
              </v-flex>
            </v-layout>
          </v-flex>

          <v-divider></v-divider>

          <v-card-actions>
            <v-layout justify-center>
              <v-btn
                color="primary"
                flat
                style="text-transform: lowercase; !important;"
                @click="downloadAppDialog = false"
              >
                {{$translate('NO_CONTINUE_USING_WEBSITE')}}
              </v-btn>
            </v-layout>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog
        v-model="activationDialog"
        width="600"
        class="mt-4"
        persistent
        no-click-animation>
        <v-card>
          <v-card-title
            class="headline"
          >
            {{$translate('USER_SUCCESS_ACTIVATED')}}
          </v-card-title>

          <v-flex xs12 style="margin-bottom: 1em;">
              <v-layout row justify-center align-center>

                <v-flex xs11>
                    <v-card class="elevation-5 pa-2" color="grey lighten-2">
                      <v-layout row>
                        <v-icon large>warning</v-icon>
                        <h3 style="text-align: left;
                        padding-left: 0.8em;">
                          {{$translate('USER_SUCCESS_ACTIVATED_LINK')}}
                        </h3>
                      </v-layout>
                      <v-flex  v-if="receivedUserId !== ''" xs12>
                        <v-card class="pa-2" color="white">
                          <h4 style="text-align: left;
                          padding-left: 0.8em;">
                            {{$translate('USER_PASS')}}
                            <b>{{receivedUserId}}</b>
                          </h4>
                        </v-card>
                      </v-flex>
                    </v-card>
                </v-flex>
              </v-layout>
            <v-layout row>
              <v-flex xs8 style="margin-top: 4em;" class="pl-2">
                  <h4 style="text-align: left;
                  margin-bottom: 1em;
                  padding-left: 0.8em;">
                    {{$translate('USER_SUCCESS_ACTIVATED_DOWN')}}
                  </h4>
                <v-layout row justify-space-around>
                  <a style="padding: 1em;"
                     :href="$store.getters.getCustomerPreferences.ios_app_url"
                     target="_blank"
                     rel="noopener noreferrer">
                    <v-img style="width: 120px; margin-top: 2px;" :src="require('../../assets/Download_on_the_App_Store.png')"/>
                  </a>
                  <a style="padding: 1em;"
                     :href="$store.getters.getCustomerPreferences.android_app_url"
                     target="_blank"
                     rel="noopener noreferrer">
                    <v-img width="150" :src="require('../../assets/Download_on_the_Play_Store.png')"></v-img>
                  </a>
                </v-layout>
              </v-flex>
              <v-flex xs4>
                <v-img style="width: 12em;" contain :src="mobileImage()"></v-img>
              </v-flex>
            </v-layout>
          </v-flex>

          <v-divider></v-divider>

          <v-card-actions>
            <v-layout justify-center>
              <v-btn
                color="primary"
                flat
                style="text-transform: lowercase; !important;"
                @click="cancelActivationDialog"
              >
                {{$translate('NO_CONTINUE_USING_WEBSITE')}}
              </v-btn>
            </v-layout>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>
    <v-card
      v-scroll="saveNewScrollPosition"
      class="themeBackground"
      v-resize="onResize"
    >
      <v-img :aspect-ratio="14/9"
             class="imageBlur"
             :lazy-src="setBackgroundLazyImage()"
             :src="setBackgroundImage()"></v-img>
      <div class="blokje">
      <v-card v-model="carouselIndex" class="innerCardWithCircles transparent elevation-0">
        <v-layout class="mt-4" row align-center>
          <v-btn
            class="backButton"
            v-if="showActivity"
            color="secondary"
            round
            large
            @click="goBack"
            icon
          >
            <v-icon>arrow_back_ios</v-icon>
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn
            v-if="scrollPos < 40 && $store.getters['auth/userName'] == ''"
            class="planTripButton text-capitalize"
            color="secondary"
            round
            large
            @click="goTo('Login')"
          >{{$translate('CREATE_USER')}}</v-btn>
          <v-btn
            v-if="scrollPos < 40
            && $store.getters['auth/userLevel'] < 4
            && $store.getters['auth/userName'] != ''"
            class="planTripButton text-capitalize"
            color="secondary"
            round
            large
            @click="createPartner()"
          >{{$translate('CREATE_PARTNER')}}</v-btn>
        </v-layout>
        <v-layout justify-start align-center>
          <v-btn
            class="carouselBtn"
            @click="carouselLeftChanged"
            dark
            fab
            color="secondary"
            :disabled="btnCarouselDisable">
            <v-icon x-large>keyboard_arrow_left</v-icon>
          </v-btn>
        </v-layout>
        <v-layout justify-end align-center>
          <v-btn
            class="carouselBtn"
            @click="carouselRightChanged"
            fab
            color="secondary"
            dark
            :disabled="btnCarouselDisable"
          >
            <v-icon dark x-large>keyboard_arrow_right</v-icon>
          </v-btn>
        </v-layout>
        <v-card class="transparent slideshow v-card--flat">
          <v-layout row wrap align-center justify-left>
            <v-card dark
                    flat
                    color="transparent"
                    height="500px"
                    class="rounded-card-event-selector">
              <v-list id="circle-list">
                <transition
                  name="midCircleAnimation"
                  :enter-active-class="'animated ' + animationCircleEnterClass + ' faster'"
                  :leave-active-class="'animated ' + animationCircleLeaveClass + ' faster'"
                >
                  <v-card
                    class="transparent elevation-0 rounded-inner-card pa-2"
                    v-if="showMidCircle"
                  >
                    <v-layout column align-center>
                      <div
                        :style="`background-color: ${$vuetify.theme.primary}`"
                        size="280"
                        class="avatarTheme"
                        v-if="activityType !== 'Tour'"
                        :aspect-ratio="14/9"
                        @click="getEventsListForTheme()"
                      ></div>
                      <v-flex
                        @click="getEventsListForTheme()"
                        style="padding-left: 1em;"
                        :style="`color: white`"
                        class="cardNamePosition text-xs-center"
                        v-if="activityType !== 'Tour'"
                      >{{setCardName()}}</v-flex>
                      <i>
                        <v-flex
                          @click="getEventsListForTheme()"
                          style="padding-left: 1em;"
                          :style="`color: white;`"
                          class="cardActivitiesPosition text-xs-center"
                          v-if="activityType !== 'Tour' && themeSelected.hasOwnProperty('Children')"
                        >{{themeSelected.Children.length + " " + $translate('ACTIVITIES')}}</v-flex>
                      </i>
                      <v-btn
                        v-if="!bookOneEvent && themeSelected.hasOwnProperty('Children')"
                        color="secondary"
                        round
                        :disabled="themeSelected.Children.length === 1"
                        large
                        class="buttonInCarouselDiv text-capitalize"
                        style="font-size: 20px; margin-left: 2em;"
                        @click="getEventsForThisTheme(themeSelected.EventId)"
                      >{{$translate('VIEW_ACTIVITIES')}}</v-btn>
                    </v-layout>
                  </v-card>
                </transition>
                <transition
                  name="midCircleAnimation"
                  :enter-active-class="'animated ' + animationCircleEnterClass + ' faster'"
                  :leave-active-class="'animated ' + animationCircleLeaveClass + ' faster'"
                ></transition>
              </v-list>
            </v-card>
          </v-layout>
        </v-card>
      </v-card>
      </div>
      <v-flex></v-flex>
      <div pa-2 class="blokje">
        <v-flex xs12 mb-3 style=" margin-bottom: 5em !important;">
          <v-card class="rounded-card">
            <v-form class="formMET">
              <v-layout row align-center justify-center>
                <v-flex
                  xs12
                  pa-2
                  style="border-radius: 9px;"
                  :style="`background-color: ${$vuetify.theme.secondary}`"
                >
                  <v-layout row ml-1 mr-1 justify-space-between>
                    <h1
                      class="mt-2 searchBarText"
                    >{{$translate('SEARCH_ACTIVITY')}}</h1>
                    <v-flex xs3>
                      <v-menu
                        ref="menu1"
                        :close-on-content-click="true"
                        v-model="menu1"
                        :nudge-right="40"
                        :return-value.sync="chosenStartDate"
                        lazy
                        transition="scale-transition"
                        offset-y
                        full-width
                        min-width="290px"
                      >
                        <v-text-field
                          color="white"
                          dark
                          @change="checkForDates()"
                          @input="checkForDates()"
                          slot="activator"
                          v-model="computedDateFormattedStartDate"
                          :label="$translate('DATE')"
                          hide-details
                          append-icon="event"
                          readonly
                          ref="eventForm"
                        ></v-text-field>
                        <v-date-picker
                          first-day-of-week="1"
                          :min="nowDate"
                          @change="checkForDates()"
                          color="primary"
                          v-model="chosenStartDate"
                          @input="$refs.menu1.save(chosenStartDate)"
                          no-title
                        />
                      </v-menu>
                    </v-flex>
                    <v-flex xs3>
                      <v-menu
                        ref="menu2"
                        :close-on-content-click="true"
                        v-model="menu2"
                        :nudge-right="40"
                        :return-value.sync="chosenEndDate"
                        lazy
                        transition="scale-transition"
                        offset-y
                        full-width
                        min-width="290px"
                      >
                        <v-text-field
                          color="white"
                          dark
                          @change="checkForDates()"
                          @input="checkForDates()"
                          slot="activator"
                          v-model="computedDateFormattedEndDate"
                          :label="$translate('DATE')"
                          class
                          hide-details
                          append-icon="event"
                          readonly
                          ref="eventForm"
                        ></v-text-field>
                        <v-date-picker
                          :min="nowDate"
                          first-day-of-week="1"
                          color="primary"
                          v-model="chosenEndDate"
                          @change="checkForDates()"
                          @input="$refs.menu2.save(chosenEndDate)"
                          no-title
                        />
                      </v-menu>
                    </v-flex>
                    <v-btn
                      v-if="!bookOneEvent"
                      color="primary"
                      round
                      :disabled="searchButton"
                      class="buttonInSearchActivityStroke"
                      large
                      @click="searchActivityWithSelectedDates(computedDateFormattedStartDate,
                       computedDateFormattedEndDate)"
                    >{{$translate('SEARCH')}}</v-btn>
                  </v-layout>
                </v-flex>
              </v-layout>
            </v-form>
          </v-card>
        </v-flex>
        <v-layout ref="homepageThemes" row wrap style=" margin-bottom: 3em !important;">
          <v-flex xs12 pa-2>
            <h1 :style="`color: ${$vuetify.theme.primary}`">{{$translate('ACTIVITIES')}}</h1>
            <h3
              :style="`color: ${$vuetify.theme.primary}`"
            >{{$translate('ACTIVITIES_DESC')}}</h3>
          </v-flex>
          <v-flex v-for="(item, index) in themes" :key="index" xs4 d-flex>
            <v-hover>
              <v-card class="d-flex themeCard rounded-card elevation-3" slot-scope="{ hover }">
                <v-flex xs12>
                  <v-img
                    :lazy-src="item.Picture"
                    :src="item.PictureUrl"
                    aspect-ratio="1"
                    class="grey lighten-2 themeImage rounded-card"
                  >
                    <template v-slot:placeholder>
                      <v-layout fill-height align-center justify-center ma-0>
                        <v-progress-circular indeterminate color="grey lighten-5"/>
                      </v-layout>
                    </template>
                    <v-flex xs12>
                      <v-card class="elevation-0 transparent">
                        <h2
                          mt-1
                          class="activityText translationName"
                        >{{item.EventTranslationName}}</h2>
                        <h3
                          v-if= "item.Children.length < 1"
                          class="activityText"
                        >{{item.Children.length + " " + $translate('ACTIVITIES')}}</h3>
                        <h3
                          v-else-if= "item.Children.length < 2"
                          class="activityText"
                        >{{item.Children.length + " " + $translate('ACTIVITY')}}</h3>
                        <h3
                          v-else
                          class="activityText"
                        >{{item.Children.length + " " + $translate('ACTIVITIES')}}</h3>
                      </v-card>
                    </v-flex>
                  </v-img>
                </v-flex>
                <v-expand-transition>
                  <div
                    v-if="hover"
                    class="d-flex transition-fast-in-fast-out v-card--reveal white--text"
                    style="height: 100%; "
                    :style="`background-color: ${$vuetify.theme.primary}`"
                  >
                    <v-layout column fill-height>
                      <h2>{{item.EventTranslationName}}</h2>
                      <v-card class="scrollableVCard elevation-0 transparent">
                        <p pt-1 class="themeDescription">{{item.Description}}</p>
                      </v-card>
                      <v-layout align-end justify-end row fill-height>
                        <v-btn
                          :disabled="item.Children.length < 1"
                          color="secondary"
                          round
                          @click="getEventsForThisTheme(item.EventId)"
                        >{{$translate('VIEW_ACTIVITIES')}}</v-btn>
                      </v-layout>
                    </v-layout>
                  </div>
                </v-expand-transition>
              </v-card>
            </v-hover>
          </v-flex>
        </v-layout>
        <v-layout
          ref="homepageEvents"
          v-if="seeTheListOfEvents"
          row
          wrap
          style="border-radius: 10px;
          margin-bottom: 10em !important;
          background-color: rgba(211,211,211)"
        >
          <v-flex xs12 pa-2>
            <v-layout row>
              <v-flex xs8>
                <h1
                  :style="`color: ${$vuetify.theme.primary}`"
                >{{selectedTheme.EventTranslationName}}</h1>
                <p :style="`color: ${$vuetify.theme.primary}`">{{selectedTheme.Description}}</p>
              </v-flex>
              <v-flex xs6>
                <v-layout row justify-end align-end>
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                      <v-btn @click="hideTheListOfEvents()" color="secondary" round v-on="on">
                        <v-icon large>close</v-icon>
                      </v-btn>
                    </template>
                    <span>{{$translate('CLOSE_ACTIVITIES')}}</span>
                  </v-tooltip>
                </v-layout>
              </v-flex>
            </v-layout>
          </v-flex>
          <v-flex v-for="(item, index) in selectedTheme.Children" :key="index" xs4 d-flex>
            <v-card class="d-flex themeCard rounded-card elevation-3">
              <v-layout column>
                <v-card class="v-card--flat rounded-card" style="height: 50%;">
                  <v-img
                    :lazy-src="item.Picture"
                    :src="item.PictureUrl"
                    aspect-ratio="1"
                    class="grey lighten-2 themeImage rounded-card"
                  >
                    <v-layout justify-end align-end>
                      <v-icon
                        :color="item.Favourite ? 'red' : 'grey'"
                        large
                        @click="toggleFavourite(item)"
                      >favorite</v-icon>
                    </v-layout>
                  </v-img>
                </v-card>
                <v-card class="v-card--flat" style="height: 40%; padding: 1em;">
                  <v-card class="elevation-0 transparent scrollbarInEvents">
                    <h2>{{item.EventTranslationName}}</h2>
                    <p>{{item.Description}}</p>
                  </v-card>
                </v-card>
                <v-card style="height: 10%;" class="rounded-card">
                  <v-layout align-end justify-end fill-height>
                    <v-btn
                      @click="goToActvityDetailScreen(item)"
                      color="secondary"
                      round
                    ><h3>{{$translate('GO_INCIDENT')}}
                        <v-icon style="font-size: 1.2em !important;">arrow_forward_ios</v-icon>
                      </h3>
                    </v-btn>
                  </v-layout>
                </v-card>
              </v-layout>
            </v-card>
          </v-flex>
        </v-layout>
      </div>
      <div class="middleInformation"   style="height: 55em !important;">
        <v-img
          :aspect-ratio="14/9"
          class="imageBlur"
          :src="setBackgroundImageForAccount()"
          style="margin-bottom: 10em;"
        ></v-img>
       <v-layout  align-center justify-center row fill-height>
         <v-card class="rounded-card-closed-passport">
           <v-carousel
             v-model="slide"
             class="elevation-0"
             hide-controls
             hide-delimiters
             light
             style="height: 100%"
           >
             <v-carousel-item class="elevation-0">
               <v-card class="transparent elevation-0">
                 <v-layout row>
                   <v-flex xs6>
                     <h1 class="mb-4">{{appTitle}}</h1>
                     <p class="mb-4">{{appDescription}}</p>
                     <v-layout row>
                       <a :href="$store.getters.getCustomerPreferences.ios_app_url"
                          target="_blank"
                          rel="noopener noreferrer">
                         <v-img style="width: 120px; margin-top: 2px;" :src="require('../../assets/Download_on_the_App_Store.png')"/>
                       </a>
                       <a :href="$store.getters.getCustomerPreferences.android_app_url"
                          target="_blank"
                          rel="noopener noreferrer">
                         <v-img width="150" :src="require('../../assets/Download_on_the_Play_Store.png')"></v-img>
                       </a>
                     </v-layout>
                   </v-flex>
                   <v-img height="500" width="100" contain :src="mobileImage()"></v-img>
                 </v-layout>
               </v-card>
             </v-carousel-item>
             <v-layout align-end justify-center row class="carouselBtn">
               <v-icon
                 :style="`color: ${$vuetify.theme.primary}`"
                 @click="cycle('back')"
                 v-if="slide == 1"
               >adjust</v-icon>
               <v-icon :style="`color: ${$vuetify.theme.primary}`" v-else>brightness_1</v-icon>
               <v-icon
                 :style="`color: ${$vuetify.theme.primary}`"
                 @click="cycle('forward')"
                 v-if="slide == 0"
               >adjust</v-icon>
               <v-icon :style="`color: ${$vuetify.theme.primary}`" v-else>brightness_1</v-icon>
             </v-layout>
           </v-carousel>
         </v-card>
       </v-layout>
      </div>
      <div class="blokje" v-if="!dontShowCalendar">
        <v-flex ref="homepageCalendar" class="mt-4" v-if="showCalendar" xs12 pa-2>
          <h1 :style="`color: ${$vuetify.theme.primary}`">{{$translate('CALANDER_NAME')}}</h1>
          <h3
            :style="`color: ${$vuetify.theme.primary}`"
          >{{$translate('WHATS_ON_DESC')}}</h3>
        </v-flex>
        <v-layout row wrap>
          <v-flex xs3>
            <v-card class="rounded-card" style="text-align:center">
              <v-layout column>
                <h2 :style="`color: ${$vuetify.theme.primary}`">
                  {{$translate('FILTER_RESULTS')}}</h2>
                <v-btn
                  @click="getCalendar(getCurrentDate(), getCurrentDate())"
                  color="secondary"
                  class="ml-4 mr-4 mb-4 mt-2"
                >
                  <h3>{{$translate('TODAY')}}</h3>
                </v-btn>
                <v-btn
                  @click="getCalendar(getCurrentDate(), getNextWeekFromToday())"
                  color="secondary"
                  class="ml-4 mr-4 mb-4"
                >
                  <h3>{{$translate('NEXT_7_DAYS')}}</h3>
                </v-btn>
                <v-btn
                  @click="getCalendar(getCurrentDate(), getNextMonthFromToday())"
                  color="secondary"
                  class="ml-4 mr-4 mb-4"
                >
                  <h3>{{$translate('NEXT_30_DAYS')}}</h3>
                </v-btn>
                <v-flex xs4>
                  <v-card class="ml-4 mr-4 mb-4 elevation-0 datePickerHomePage">
                    <h2
                      style="text-align:center"
                      :style="`color: ${$vuetify.theme.primary}`"
                    >{{$translate('SELECT_SPEC_DAYS')}}</h2>
                    <br />
                    <br />
                    <h3
                      class="ml-4"
                      style="text-align:left"
                      :style="`color: ${$vuetify.theme.primary}`"
                    >{{$translate('SELECT_FROM')}}:</h3>
                    <v-menu
                      ref="menu3"
                      :close-on-content-click="true"
                      v-model="menu3"
                      :nudge-right="40"
                      :return-value.sync="chosenSecondStartDate"
                      lazy
                      transition="scale-transition"
                      offset-y
                      full-width
                      min-width="290px"
                    >
                      <v-text-field
                        class="datePickerStyling ml-4"
                        slot="activator"
                        @change="checkForDates2()"
                        @input="checkForDates2()"
                        v-model="computedDateFormattedSecondStartDate"
                        hide-details
                        append-icon="event"
                        readonly
                        ref="eventForm"
                      ></v-text-field>
                      <v-date-picker
                        :min="nowDate"
                        @change="checkForDates2()"
                        first-day-of-week="1"
                        color="primary"
                        v-model="chosenSecondStartDate"
                        @input="$refs.menu3.save(chosenSecondStartDate)"
                        no-title
                      />
                    </v-menu>
                    <h3
                      class="ml-4"
                      style="text-align:left"
                      :style="`color: ${$vuetify.theme.primary}`"
                    >{{$translate('SELECT_UNTIL')}}:</h3>
                    <v-menu
                      ref="menu4"
                      :close-on-content-click="true"
                      v-model="menu4"
                      :nudge-right="40"
                      :return-value.sync="chosenSecondEndDate"
                      lazy
                      transition="scale-transition"
                      offset-y
                      full-width
                      min-width="290px"
                    >
                      <v-text-field
                        class="datePickerStyling ml-4"
                        slot="activator"
                        @change="checkForDates2()"
                        @input="checkForDates2()"
                        v-model="computedDateFormattedSecondEndDate"
                        hide-details
                        append-icon="event"
                        readonly
                        ref="eventForm"
                      ></v-text-field>
                      <v-date-picker
                        first-day-of-week="1"
                        :min="nowDate"
                        @change="checkForDates2()"
                        color="primary"
                        v-model="chosenSecondEndDate"
                        @input="$refs.menu4.save(chosenSecondEndDate)"
                        no-title
                      />
                    </v-menu>
                    <v-btn
                      :disabled="searchButton2"
                      v-if="!bookOneEvent"
                      color="secondary"
                      round
                      class="buttonInSearchActivityStroke"
                      large
                      @click="searchActivityWithSelectedDates(computedDateFormattedSecondStartDate,
                      computedDateFormattedSecondEndDate)"
                    >{{$translate('SEARCH')}}</v-btn>
                  </v-card>
                </v-flex>
              </v-layout>
            </v-card>
          </v-flex>
          <v-flex xs9>
            <v-card
              flat
              v-if="showCalendar"
              elevation="3"
              class="grey lighten-2 rounded-card ml-1"
              style=" margin-bottom: 1em !important; margin-top: -0.5em;"
            >
              <!-- card panel for the calendar -->
              <template v-for="(eventData, key) in paginatedCalendar">
                <v-card
                  v-if="eventData.hasOwnProperty('EventId')"
                  id="getEventDetails"
                  flat
                  :key="key"
                >
                  <v-layout
                    @click="getEventDetails(eventData, eventData.EventDate, false)"
                    style="margin: 0.5em;"
                  >
                    <!-- If the image data is empty it has a no image picture -->
                    <img
                      v-if="eventData.Picture !== ''"
                      contain :aspect-ratio="16/9"
                      class="pa-1 calendarImage"
                      :src="eventData.Picture"
                    />
                    <img
                      v-else
                      class="calendarImage"
                      aspect-ratio="1"
                      src="https://cdn3.iconfinder.com/data/icons/abstract-1/512/no_image-512.png"
                    />
                    <v-layout class="ml-2 column">
                      <h3 :style="`color: ${$vuetify.theme.primary}`">{{eventData.Name}}</h3>
                      <p
                        class="suggestionsTime"
                        v-if="eventData.BatchFrequency > 0"
                      >{{eventData.StartTime}} -
                        {{eventData.EndTime}},
                        {{$translate('EVENT_STARTS_EVERY')}}
                        {{(eventData.BatchFrequency / 60).toFixed(0)}}
                        {{$translate('MINUTES')}}</p>
                      <p
                        class="suggestionsTime"
                        v-if="eventData.BatchFrequency > 0"
                      >{{$translate('EVENT_DURATION')}}
                        {{(eventData.Duration / 60).toFixed(0)}}
                        {{$translate('MINUTES')}}</p>
                      <p
                        class="suggestionsTime"
                        v-else
                      >{{eventData.StartTime}} -
                        {{eventData.EndTime}},
                        {{$translate('EVENT_DURATION')}}
                        {{(eventData.Duration / 60).toFixed(0)}}
                        {{$translate('MINUTES')}}</p>
                      <p>Date: {{eventData.EventDate}}</p>
                    </v-layout>
                    <v-layout align-end justify-end row>
                      <v-list-tile-action>
                        <v-btn
                          v-if="!bookOneEvent"
                          color="secondary"
                          round
                          class="mt-2"
                          large
                          @click="goToActvityDetailScreen(eventData)"
                        >{{$translate('GO_INCIDENT')}}</v-btn>
                      </v-list-tile-action>
                    </v-layout>
                  </v-layout>
                  <v-card
                    flat
                    v-if="extraEventInfo
                    && chosenEventId == eventData.EventId
                    && eventData.BatchGroupId == chosenBatchGroupId
                    && chosenDate == eventData.EventDate"
                  >
                    <v-layout class="calendar-expansion-content" ma-2 row>
                      <v-card-text class="lighten-3">{{eventDescription}}</v-card-text>
                      <!-- If the image data is empty it has a no image picture -->
                      <img
                        :aspect-ratio="14/9"
                        class="suggestionsImage"
                        v-if="!eventPicture == ''"
                        :src="eventPicture"
                      />
                      <img
                        :aspect-ratio="14/9"
                        class="suggestionsImage"
                        v-else
                        src="https://cdn3.iconfinder.com/data/icons/abstract-1/512/no_image-512.png"
                      />
                    </v-layout>
                  </v-card>
                </v-card>
                <v-card v-else
                        class="v-card--flat"
                >
                  <p class="headline dateTitle">- {{eventData}} -</p>
                </v-card>
              </template>
            </v-card>
            <v-layout justify-end row style="margin-bottom: 10em;">
              <v-pagination
                class="pagination mt-0"
                total-visible="5"
                v-model="page"
                :length="nPages"
                @input="selectPage"
                @next="nextPage"
                @previous="previousPage"
              ></v-pagination>
            </v-layout>
          </v-flex>
        </v-layout>
      </div>
      <div class="blokje" style="min-height: 0 !important;">
        <v-flex ref="homepageMapSection" v-if="showCalendar" xs6 class="mapSide ml-4" pa-2>
          <h1 :style="`color: ${$vuetify.theme.primary}`">{{$translate('MAP_TITLE')}}</h1>
          <h3
            :style="`color: ${$vuetify.theme.primary}`"
          >{{$translate('WHAT_IS_WHERE_DESC')}}</h3>
        </v-flex>
      </div>
      <Map class="ml-4" ref="homepageMap" :settings="mapSettings"></Map>
    </v-card>
  </div>
  <div v-else>
    <div class="text-xs-center">
      <v-dialog
        v-model="downloadAppDialog"
        width="600"
        persistent
        no-click-animation
      >
        <v-card>
          <v-card-title
            class="headline grey lighten-2"
          >
            {{appTitle}}
          </v-card-title>

          <v-flex xs12 style="margin-bottom: 1em;">
            <v-layout row>
                <v-flex xs6>
                  <v-layout column justify-space-around>
                    <h3 style="text-align: center;
                    padding-left: 0.8em;">
                      {{$translate('DOWNLOAD')}}
                    </h3>
                    <a style="padding: 1em;"
                       :href="$store.getters.getCustomerPreferences.ios_app_url"
                       target="_blank"
                       rel="noopener noreferrer">
                      <v-img style="width: 120px;
                      margin-top: 2px;" :src="require('../../assets/Download_on_the_App_Store.png')"/>
                    </a>
                    <a :href="$store.getters.getCustomerPreferences.android_app_url"
                       target="_blank"
                       rel="noopener noreferrer">
                      <v-img width="150" :src="require('../../assets/Download_on_the_Play_Store.png')"/>
                    </a>
                  </v-layout>
                </v-flex>
                <v-flex xs6>
                  <v-img style="width: 12em;"
                         contain
                         :src="mobileImage()"/>
                </v-flex>
            </v-layout>
          </v-flex>
          <v-divider></v-divider>
          <v-card-actions>
            <v-layout justify-center>
              <v-btn
                color="primary"
                flat
                style="text-transform: lowercase; !important;"
                @click="downloadAppDialog = false"
              >
                {{$translate('NO_CONTINUE_USING_WEBSITE')}}
              </v-btn>
            </v-layout>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>
    <v-dialog
      v-model="activationDialog"
      width="600"
      class="mt-4"
      persistent
      no-click-animation
    >
      <v-card class="pt-4">
        <v-card-title
          class="headline"
        >
          {{$translate('USER_SUCCESS_ACTIVATED')}}
        </v-card-title>

        <v-flex xs12 style="margin-bottom: 1em;">
          <v-layout row justify-center align-center>

            <v-flex xs11>
              <v-card class="elevation-5 pa-2" color="grey lighten-2">
                <v-layout row>
                  <v-icon large>warning</v-icon>
                  <h3 style="text-align: left;
                  padding-left: 0.8em;">
                    {{$translate('USER_SUCCESS_ACTIVATED_LINK')}}
                  </h3>
                </v-layout>
                <v-flex  v-if="receivedUserId !== ''" xs12>
                  <v-card class="pa-2" color="white">
                    <h3 style="text-align: left;
                    padding-left: 0.8em;">
                      {{$translate('USER_PASS')}}{{receivedUserId}}
                    </h3>
                  </v-card>
                </v-flex>
              </v-card>
            </v-flex>
          </v-layout>
          <v-layout row>
            <v-flex xs12 style="margin-top: 4em;" class="pa-2">
              <h4 style="text-align: left;
              margin-bottom: 1em;">
                {{$translate('USER_SUCCESS_ACTIVATED_DOWN')}}
              </h4>
              <v-layout row justify-center>
                <a style="padding: 1em;"
                   :href="$store.getters.getCustomerPreferences.ios_app_url"
                   target="_blank"
                   rel="noopener noreferrer">
                  <v-img style="width: 120px; margin-top: 2px;" :src="require('../../assets/Download_on_the_App_Store.png')"></v-img>
                </a>
                <a style="padding: 1em;"
                   :href="$store.getters.getCustomerPreferences.android_app_url"
                   target="_blank"
                   rel="noopener noreferrer">
                  <v-img width="150" :src="require('../../assets/Download_on_the_Play_Store.png')"></v-img>
                </a>
              </v-layout>
            </v-flex>
          </v-layout>
        </v-flex>

        <v-divider></v-divider>

        <v-card-actions>
          <v-layout justify-center>
            <v-btn
              color="primary"
              flat
              style="text-transform: lowercase; !important;"
              @click="cancelActivationDialog"
            >
              {{$translate('NO_CONTINUE_USING_WEBSITE')}}
            </v-btn>
          </v-layout>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-card
      class="themeBackgroundMobile"
      v-resize="onResize"
    >
      <v-img :aspect-ratio="14/9" class="imageBlurMobile" :src="setBackgroundImage()"></v-img>
      <v-card v-model="carouselIndex" class="innerCardWithCircles transparent elevation-0">
        <v-layout justify-start align-end>
          <v-btn
            class="carouselBtnMobile"
            @click="carouselLeftChanged"
            dark
            fab
            color="secondary"
            :disabled="btnCarouselDisable"
          >
            <v-icon x-large>keyboard_arrow_left</v-icon>
          </v-btn>
        </v-layout>
        <v-layout justify-end align-end>
          <v-btn
            class="carouselBtnMobile"
            @click="carouselRightChanged"
            fab
            color="secondary"
            dark
            :disabled="btnCarouselDisable"
          >
            <v-icon dark x-large>keyboard_arrow_right</v-icon>
          </v-btn>
        </v-layout>
        <v-card class="transparent slideshow v-card--flat">
          <v-layout row wrap align-center justify-left>
            <v-card dark flat color="transparent" class="rounded-card-event-selector-mobile">
              <v-list id="circle-list">
                <transition
                  name="midCircleAnimation"
                  :enter-active-class="'animated ' + animationCircleEnterClass + ' faster'"
                  :leave-active-class="'animated ' + animationCircleLeaveClass + ' faster'"
                >
                  <v-card
                    @click="getEventsForThisTheme(themeSelected.EventId)"
                    class="transparent elevation-0 rounded-inner-card-mobile pa-2"
                    v-if="showMidCircle"
                  >
                    <v-layout column align-center>
                      <div
                        size="280"
                        class="avatarThemeMobile"
                        v-if="activityType !== 'Tour'"
                        :aspect-ratio="14/9"
                        @click="getEventsListForTheme()"
                      ></div>
                      <div
                        @click="getEventsListForTheme()"
                        style="padding-top: 1em; padding-left: -0.1em;"
                        :style="`color: ${$vuetify.theme.primary}`"
                        class="cardNamePositionMobile text-xs-center"
                        v-if="activityType !== 'Tour'"
                      >{{setCardName()}}</div>
                      <i>
                        <v-flex
                          @click="getEventsListForTheme()"
                          :style="`color: ${$vuetify.theme.primary}`"
                          class="cardActivitiesPositionMobile text-xs-center"
                          v-if="activityType !== 'Tour' && themeSelected.hasOwnProperty('Children')"
                        >{{themeSelected.Children.length + " " + $translate('ACTIVITIES')}}</v-flex>
                      </i>
                    </v-layout>
                  </v-card>
                </transition>
                <transition
                  name="midCircleAnimation"
                  :enter-active-class="'animated ' + animationCircleEnterClass + ' faster'"
                  :leave-active-class="'animated ' + animationCircleLeaveClass + ' faster'"
                ></transition>
              </v-list>
            </v-card>
          </v-layout>
        </v-card>
      </v-card>
      <v-layout row wrap style="margin-bottom: 3em !important;">
        <v-card class="highlightsMobile elevation-0 transparent">
          <v-flex xs12 pa-2>
            <h1 :style="`color: ${$vuetify.theme.primary}`">{{$translate('ACTIVITIES')}}</h1>
            <h3
              :style="`color: ${$vuetify.theme.primary}`"
            >{{$translate('ACTIVITIES_DESC')}}</h3>
          </v-flex>
          <v-flex v-for="(item, index) in themes" :key="index" xs12 d-flex>
            <v-hover>
              <v-card class="d-flex themeCard rounded-card elevation-3" slot-scope="{ hover }">
                <v-flex xs12>
                  <v-img
                    :src="item.PictureUrl"
                    aspect-ratio="1"
                    class="grey lighten-2 themeImage rounded-card"
                  >
                    <template v-slot:placeholder>
                      <v-layout fill-height align-center justify-center ma-0>
                        <v-progress-circular indeterminate color="grey lighten-5"/>
                      </v-layout>
                    </template>
                    <v-flex xs12>
                      <v-card class="elevation-0 transparent">
                        <h2
                          mt-1
                          class="activityText translationName"
                        >{{item.EventTranslationName}}</h2>
                        <h3
                          v-if= "item.Children.length < 1"
                          class="activityText"
                        >{{item.Children.length + " " + $translate('ACTIVITIES')}}</h3>
                        <h3
                          v-else-if= "item.Children.length < 2"
                          class="activityText"
                        >{{item.Children.length + " " + $translate('ACTIVITY')}}</h3>
                        <h3
                          v-else
                          class="activityText"
                        >{{item.Children.length + " " + $translate('ACTIVITIES')}}</h3>
                      </v-card>
                    </v-flex>
                  </v-img>
                </v-flex>
                <v-expand-transition>
                  <div
                    v-if="hover"
                    class="d-flex transition-fast-in-fast-out v-card--reveal white--text"
                    style="height: 100%; "
                    :style="`background-color: ${$vuetify.theme.primary}`"
                  >
                      <v-layout column fill-height>
                        <h2>{{item.EventTranslationName}}</h2>
                        <v-card class="scrollableVCard elevation-0 transparent">
                          <p pt-1 class="themeDescription">{{item.Description}}</p>
                        </v-card>
                        <v-layout align-end justify-end row fill-height>
                          <v-btn
                            color="secondary"
                            round
                            :disabled="item.Children.length < 1"
                            @click="getEventsForThisTheme(item.EventId)"
                          >{{$translate('VIEW_ACTIVITIES')}}</v-btn>
                        </v-layout>
                      </v-layout>
                  </div>
                </v-expand-transition>
              </v-card>
            </v-hover>
          </v-flex>
        </v-card>
      </v-layout>
      <v-layout
        ref="homepageEvents"
        v-if="seeTheListOfEvents"
        row
        wrap
        style="border-radius: 10px;
        margin-bottom: 10em !important;
        background-color: rgba(211,211,211);">
        <v-card class="transparent activitiesMobile v-card--flat">
          <v-layout column>
            <v-layout row justify-end align-end>
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <v-btn @click="hideTheListOfEvents()" color="secondary" round v-on="on">
                    <v-icon large>close</v-icon>
                  </v-btn>
                </template>
                <span>{{$translate('CLOSE_ACTIVITIES')}}</span>
              </v-tooltip>
            </v-layout>
            <v-flex xs12 pa-2>
              <v-layout row>
                <v-flex xs12 class="mt-4">
                  <h1
                    :style="`color: ${$vuetify.theme.primary}`"
                  >{{$translate('ACTIVITIES_FOR_HIGHLIGHT')}} '{{selectedTheme.Name}}'</h1>
                  <p :style="`color: ${$vuetify.theme.primary}`">{{selectedTheme.Description}}</p>
                </v-flex>
              </v-layout>
            </v-flex>
          </v-layout>
          <v-flex v-for="(item, index) in selectedTheme.Children" :key="index" xs12 d-flex>
            <v-card class="d-flex themeCard rounded-card elevation-3">
              <v-layout column>
                <v-img
                  :src="item.PictureUrl"
                  aspect-ratio="1"
                  class="grey lighten-2 themeImage rounded-card"
                >
                  <v-layout justify-end align-end>
                    <v-icon
                      :color="item.Favourite ? 'red' : 'grey'"
                      large
                      @click="toggleFavourite(item)"
                    >favorite</v-icon>
                  </v-layout>
                </v-img>
                <div style="padding: 1em;">
                  <h2>{{item.EventTranslationName}}</h2>
                  <p>{{item.Description}}</p>
                  <v-btn
                    @click="goToActvityDetailScreen(item)"
                    color="secondary"
                    round
                  >Read more</v-btn>
                </div>
              </v-layout>
            </v-card>
          </v-flex>
        </v-card>
        <v-flex ref="homepageMapSection" v-if="showCalendar" xs12 class="mapSide ml-4" pa-2>
        <h1 :style="`color: ${$vuetify.theme.primary}`">{{$translate('MAP_TITLE')}}</h1>
        <h3
          :style="`color: ${$vuetify.theme.primary}`"
        >{{$translate('WHAT_IS_WHERE_DESC')}}</h3>
      </v-flex>
      </v-layout>
      <v-layout justify-center>
        <v-card v-if="showCalendar" class="mapForHomepageMobile v-card--flat">
          <mapOverview></mapOverview>
        </v-card>
      </v-layout>
    </v-card>
  </div>
</template>

<script>
import { timeout } from 'q';
import * as dssRequest from '@/api/dssRequest';
import BaseObject from '@/objects/BaseObject';
import { setTimeout } from 'timers';
import { mapGetters } from 'vuex';
import _ from 'lodash';
import animate from 'animate.css';
import MapOverview from '@/components/Map_Overview';
import { ui_helpers } from '@/shared/ui_helpers.js';
import appConfig from '../../../config/app_config.js';
import BaseComponent from '../base/BaseComponent.vue';
import OperationalScreen_BaseQuadrant from '../OperationalScreen/OperationalScreen_BaseQuadrant';
import OperationalScreen_MapQuadrant from '../OperationalScreen/OperationalScreen_MapQuadrant';
import { store } from '../../store';
import Map from "../../Maps/Map";
import MapObject from "../../Maps/MapObject";
import * as ol from "openlayers";

export default {
  name: 'Homepage',
  extends: BaseComponent,
  extends: OperationalScreen_BaseQuadrant,
  mixins: [ui_helpers],
  components: {
    OperationalScreen_MapQuadrant,
    MapOverview,
    Map,
  },
  data() {
    return {
      /* --
      Homepage map
      -- */
      allMarkers: [],
      homepageMap: {},
      mapSettings: {
        name: 'homepageMap',
        view: {
          zoom: 11,
        },
        interactions: {
          doubleClickZoom: false,
          dragAndDrop: true,
          dragPan: true,
          keyboardPan: true,
          keyboardZoom: false,
          mouseWheelZoom: false,
          pointer: true,
          select: true,
        },
        controls: {
          zoomControls: true,
          filterOption: false,
        },
        style: 'width: 99%; height: calc(75vh); margin-bottom: 3em;',
      },
      /* --
      End of homepage map
      -- */
      receivedUserId: '',
      // app screen
      activationDialog: false,
      downloadAppDialog: false,
      appTitle: '',
      appDescription: '',

      parentEventId: '',
      onlyOnSearch: false,
      levelbar: 90,
      // Carousel
      slide: 0,
      iphoneAppPicture: '',
      scrollPos: '',
      // slideShow
      slideShow: {},

      // Order
      order: {},

      // Date picker
      myModel: {},
      nowDate: new Date().toISOString().slice(0, 10),
      menu1: false,
      menu2: false,
      menu3: false,
      menu4: false,
      chosenStartDate: '',
      chosenEndDate: '',
      chosenSecondStartDate: '',
      chosenSecondEndDate: '',

      // Calendar
      searchButton2: true,
      searchButton: true,
      dontShowCalendar: false,
      extraEventInfo: false,
      showCalendar: false,
      paginatedCalendar: [],
      page: 1,
      nPages: 1,
      elementXpage: 6,
      calendarItems: [],
      firstDate: '',
      secondDate: '',

      // To show the event with the data
      eventDescription: '',
      eventPicture: '',
      NoFrequency: 0,
      transport: {},
      eventData: {},
      chosenEventId: '',
      chosenDate: '',
      chosenBatchGroupId: '',

      // Events
      selectedTheme: {},
      selectedLocation: {},
      seeTheListOfEvents: false,
      // seeEventsOfLocationList: false,

      // Initialising variables
      bookOneEvent: false,
      languageChanged: false,
      animationCircleEnterClass: 'bounceInLeft', // Type of animation on enter
      animationCircleLeaveClass: 'bounceOutRight', // Type of animation on leave
      themes: [], // The array contains the themes
      themeSelected: {}, // The objects contains the data from a theme
      activitySelected: {}, // The object contains the data from a child
      activityType: '', // the type of activity
      selectedChildFromActivity: {}, // The object contains the data from a child from a child
      fontColor: '', // fontColor for the circles
      defaultImage: '', // The default image when no image is available
      mobilePhoneActive: false, // Turns to true when the user opened the website from a mobile phone
      showActivity: false, // Turns to true when a child is opened
      noChildren: false, // Turns to true when no children for a theme/activity are available
      activityChildrensActive: false, // Turns to true when childs have childs
      childrensOpened: false, // Turns to true when children from children are opened
      carouselHeight: 1280, // Initial height for the carousel
      carouselIndex: 0, // Initial index for the carousel
      eventIndex: -1,
      childEventIndex: -1,
      clientTheme: -1,
      clientEvent: -1,
      btnCarouselDisable: false, // toggles the Carousel buttons on or off
      circleQuantity: 0, // contains the ammount of outer circles
      showDiscTags: false, // toggles the animation for the discription and tags on or off
      showMidCircle: false, // toggles the animation for the mid circle on or off
      showCircle: false, // toggles the animation for the outer circles on or off
      showMarkerLetter: false, // toggles the animation for the markerLetters on or off
      markerLetters: {},
      customerUrlActive: false, // determens if a custum event url is active or not
      alphabet: 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'.split(''), // the alphabet for the mapMarkers
      tourActivitiesList: [], // array for all the activities inside a Tour
      tourActivitiesListToggle: false, // toggles sidebar for a Tour

      // The configuration of the map in ThemeList
      locationProps: {
        component: 'OperationalScreen_MapQuadrant',
        componentId: 'OperationalScreen_MapQuadrant_MAPOFINCIDENT',
        fullSize: true,
        hidden: false,
        location: {},
        mainMap: false,
        name: 'OperationalScreen_MapQuadrant_NPSTNJ',
        params: {
          location: {
            latitude: '53.080380',
            longitude: '4.800127',
            polyline: '',
            waypoints: '',
          },
        },
        pinned: true,
        position: {
          x: 0,
          y: 0,
        },
        profile: {
          connect: false,
          default: false,
          landing: true,
          relink: true,
          style: {
            height: 'big',
          },
        },
        height: 'height: 650px; width: 650px;',
        showBackButton: true,
        showToolbar: false,
        signalObjectMap: [],
        tag: '',
        interaction: true,
        tooltip: false,
        rightClick: false,
        includeCenterPoint: false,
        zoomControls: false,
        sizeOffset: 102,
      },
      userData: {},
      userDetails: {},
      form: {},
      dateOfBirth: null,
    };
  },
  watch: {
    _userLanguage(newV, oldV) {
      if (newV !== oldV) {
        this.languageChanged = true;
        this.retrieveNewInfoAfterLanguageChange();
        this.getTextForAPP();
      }
    },
  },
  computed: {
    computedDateFormattedDob() {
      return this.formatDate(this.dateOfBirth);
    },
    computedDateFormattedStartDate() {
      return this.formatDate(this.chosenStartDate);
    },
    computedDateFormattedEndDate() {
      return this.formatDate(this.chosenEndDate);
    },
    computedDateFormattedSecondStartDate() {
      return this.formatDate(this.chosenSecondStartDate);
    },
    computedDateFormattedSecondEndDate() {
      return this.formatDate(this.chosenSecondEndDate);
    },
    ...mapGetters({
      _centerPoint: 'getCenterPointForMap',
      _discountCards: 'getDiscountCards',
      _userLanguage: 'getUserLanguage',
      _getCalendarOnHomePage: 'getCalendarOnHomePage',
    }),
    cardPages() {
      // xl = 12, lg = 6, md = 4, sm = 3, xs = 2
      let pageSize = 3;
      if (this.$vuetify.breakpoint.xl) {
        pageSize = 6;
      } else if (this.$vuetify.breakpoint.lg) {
        pageSize = 6;
      } else if (this.$vuetify.breakpoint.md) {
        pageSize = 6;
      } else if (this.$vuetify.breakpoint.sm) {
        pageSize = 2;
      } else if (this.$vuetify.breakpoint.xs) {
        pageSize = 1;
      }

      const cardPages = [];
      for (let i = 0; i < this.themes.length; i += pageSize) {
        cardPages.push(this.themes.slice(i, i + pageSize));
      }
      return cardPages;
    },
  },
  created() {
    this.$store.commit('setSeeMapInOprMapQua', false);
    // if (this.$store.getters["auth/userName"] == "") {
    //   this.downloadAppDialog = true;
    // }

    if (this.$store.getters.getUserActivationObject.hasOwnProperty('UserId')) {
      this.receivedUserId = this.$store.getters.getUserActivationObject.UserId;
    }
    if (this.$store.getters.getUserActivatedSuccessfull === true) {
      this.activationDialog = true;
    }

    this.$store.commit('setCurrentMainComponent', 'HomePage');
    window.EventBus.listen(
      'fireNewLanguage',
      this.retrieveNewInfoAfterLanguageChange,
    );
    window.EventBus.listen('checkIfImageExist', this.checkIfImageExist);
    window.EventBus.listen('showFilteredMarkersOnMap', this.getLocations);
    window.EventBus.listen('firePlanTrip', this.planTrip);
    window.EventBus.listen('fireScrollMeTo', this.scrollMeTo);
    window.EventBus.listen('showEventsOfLocation', this.showEventsOfLocation);
    window.EventBus.listen('showEventDetailsOfActivity', this.goToActvityDetailScreen);
  },
  beforeDestroy() {
    this.$store.commit('setSeeMapInOprMapQua', true);

    this.$store.commit('setCurrentMainComponent', '');
    this.showDiscTags = false;
    this.showMidCircle = false;
    this.showCircle = false;

    window.EventBus.removeListener(
      'fireNewLanguage',
      this.retrieveNewInfoAfterLanguageChange,
    );
    window.EventBus.removeListener('checkIfImageExist', this.checkIfImageExist);
    window.EventBus.removeListener('showFilteredMarkersOnMap', this.getLocations);
    window.EventBus.removeListener('firePlanTrip', this.planTrip);
    window.EventBus.removeListener('firescrollMeTo', this.scrollMeTo);
    window.EventBus.removeListener(
      'showEventsOfLocation',
      this.showEventsOfLocation,
    );
    window.EventBus.removeListener('showEventDetailsOfActivity', this.goToActvityDetailScreen);
  },

  mounted() {
    this.getLocations();
    if (!_.isEmpty(this.$store.getters.getCalendarOnHomePage)) {
      this.page = 1;
      this.recountPage();
    } else {
      this.getCalendar(this.getCurrentDate(), this.getNextWeekFromToday(), false, true);
    }
    this.$store.commit('setUserIsInQuadrantScreen', true);
    if (this.$store.getters.getUserGoesBackToHomepage === true) {
      this.selectedTheme = this.$store.getters.getSelectedTheme;
      this.seeTheListOfEvents = true;
      setTimeout(() => {
        this.scrollMeTo('homepageEvents');
      }, 1250);
    }
    // For testing purposes
    if (this.$store.getters.getAccountInfo.LocationId !== '') {
      this.getLocationDetails();
    }
    if (!this.$store.getters.getCurrentAccountId) {
      this.getAccountInfo();
    } else {
      setTimeout(() => {
        if (this.$store.getters['auth/userName'] !== '') {
          this.getPassportData();
        }
      }, 1000);
      this.slideShow = setInterval(this.carouselRightChanged, 8000);
      this.mobilePhoneActive = this.$store.getters.getMobilePhoneActive;
      this.$store.commit('auth/setUserType', this.$route.params.type);
      this.defaultImage = require('../../assets/standard_logo_events.png');
      if (
        this.$store.getters.getCurrentEventId !== null
        && this.$store.getters.getCurrentEventId !== undefined
        && this.$store.getters.getCurrentEventId !== ''
      ) {
        this.storeCustomerEnv();
      } else {
        // this.getEvents();
        console.log('Brian getThemesforServer on 1484 is called!');
        this.getThemesFromServer();
      }
      this.onResize();
      this.saveNewScrollPosition();
    }
    this.getTextForAPP();
  },
  methods: {
    getAccountInfo() {
      // Retrieving the account info
      const payload = {};
      if (this.$store.getters.getRegion) {
        this.payload = {
          Region: this.$store.getters.getRegion,
        };
      } else if (this.$route.name === 'activateUser') {
        this.payload = {
          Region: this.$route.query.AccountName,
        };
      }
      dssRequest.doRequest(
        (response) => {
          console.log("The call 'getAccountInfo' on - Homepage.vue - was successful", response);

          if (!response.data.hasOwnProperty('AccountState')
              || !response.data.hasOwnProperty('Account')
              || !response.data.hasOwnProperty('AccountInfo')
              || !response.data.hasOwnProperty('Vat')) {
            // window.EventBus.fire('triggerGenericErrorDialog', 'W_GAI_001');
            return;
          }
          console.warn('Account state ', response.data.AccountState);
          const currentAcountInfo = BaseObject._createArrayWithObjects(response.data.Account)[0];
          const result = BaseObject._createArrayWithObjects(response.data.AccountInfo);
          const currentAccountPreferencesObjects = result.map(
            ({ Key, Type, Value }) => ({ Key, Type, Value }),
          );

          /* --
            Storing(committing) data to the cache of the web(store)
            --*/
          this.$store.commit(
            'setCustomerPreferencesObjects',
            currentAccountPreferencesObjects,
          );
          this.$store.commit(
            'setAccountVat',
            response.data.Vat,
          );
          this.$store.commit(
            'setAccountInfo',
            currentAcountInfo,
          );
          this.$store.commit(
            'setCustomerPreferences',
            prefs,
          );
          this.$store.commit(
            'setBackgroundImage',
            prefs.Background_image,
          );
          this.$store.commit(
            'setCurrentAccountId',
            currentAcountInfo.AccountId,
          );
          this.$store.commit(
            'auth/setUserType',
            this.$route.params.type,
          );
          if (!this.$store.getters.getRegion) {
            this.$store.commit(
              'setRegion',
              currentAcountInfo.AccountName,
            );
          }
          /*--
            end of committing items to the store
            --*/

          /* --
            Retrieving the photos from the assets
            --*/
          this.defaultImage = require('../../assets/standard_logo_events.png');
          if (
            this.$store.getters.getCurrentEventId !== null
            && this.$store.getters.getCurrentEventId !== undefined
            && this.$store.getters.getCurrentEventId !== ''
          ) {
            this.storeCustomerEnv();
          } else {
            // this.getEvents();
            console.log('Brian getThemesforServer on 1635 is called!');
            this.getThemesFromServer();
          }
          /*--
            end of retrieving the photos from the assets
            --*/

          window.EventBus.fire('waitForAccountState', this.$store.getters.getAccountInfo.State);
          let prefs = {};
          currentAccountPreferencesObjects.map((e) => (prefs[e.Key] = e.Value));
          setTimeout(() => {
            if (this.$store.getters['auth/userName'] !== '') {
              this.getPassportData();
            }
          }, 1000);
          this.slideShow = setInterval(this.carouselRightChanged, 8000);
          this.mobilePhoneActive = this.$store.getters.getMobilePhoneActive;
          this.onResize();
          this.saveNewScrollPosition();
        },
        (error) => {
          console.log("The call 'getAccountInfo' on - Homepage.vue - was not successful", error);
          this.showBlockCondition({
            show: true,
            message: this.$translate('NO_ACCOUNT_ID'),
          });
          // if (this.$route.name !== 'ActivateUser'
          //  && this.$route.name !== 'Payments'
          //  && this.$route.name !== 'partnerConfirmation') {
          //   parent.location.href = "https://texelmap.nl/texelmap";
          // }
        },
        'getAccountInfo',
        appConfig.dss.accountManagerObjectId,
        this.payload,
        30000,
        false,
      );
    },
    getPassportData() {
      const payload = {
        RelationType: 'User',
        Id: store.getters['auth/userName'],
        Types: {
          User: 'User',
        },
        StructuredReply: true,
      };
      dssRequest.doRequest(
        (response) => {
          console.log("The call for 'getUserData' on - Homepage.vue - was successful", response);
          if (!response.data.hasOwnProperty('UserData')) {
            // window.EventBus.fire('triggerGenericErrorDialog', 'W_GUD_001');
            return;
          }
          this.userData = response.data;
          this.userDetails = response.data.UserData.User.celldata[0];
          if (this.userDetails !== undefined) {
            if (this.userDetails[21] === '0') {
              this.userDetails[21] = null;
            }
            this.dateOfBirth = this.userDetails[21];
            if (this.userDetails[14] !== '' || this.userDetails[15] !== '' || this.userDetails[17] !== '') {
              const json_obj = JSON.parse(this.Get(`https://nominatim.openstreetmap.org/search?q=${this.userDetails[15]}+${this.userDetails[14]},+${this.userDetails[17]}&format=json&polygon=1&addressdetails=1`));
              if (!_.isEmpty(json_obj)) {
                const { lat } = json_obj[0];
                const { lon } = json_obj[0];
                this.$store.commit('setUserOrderLon', lon);
                this.$store.commit('setUserOrderLat', lat);
              }
            }
          }
        },
        (error) => {
          console.log("The call for 'getUserData' on - Homepage.vue - was not successful", error);
          // window.EventBus.fire('triggerGenericErrorDialog', 'W_GUD_002');
        },
        'getUserData',
        this.$store.getters['auth/userName'],
        payload,
        600000,
        false,
      );
    },
    getEventDetails(data, key, showBookDialog) {
      if (
        this.chosenEventId == data.EventId
          && this.chosenDate == key
          && !showBookDialog
      ) {
        this.extraEventInfo = false;
        this.chosenEventId = '';
        this.chosenDate = '';
        this.chosenBatchGroupId = '';
        return;
      }
      this.extraEventInfo = false;
      setTimeout(() => {
        this.extraEventInfo = true;
      }, 10);

      this.eventPicture = data.Picture;
      this.chosenEventId = data.EventId;
      this.chosenDate = key;
      this.chosenBatchGroupId = data.BatchGroupId;

      // When selecting an event this function will be called

      const payload = {
        EventId: Number(data.EventId),
        LanguageTagId: this.$store.getters.getUserLanguage,
      };

      dssRequest.doRequest(
        (response) => {
          console.log(
            "The call 'getEventDetailsV2' on - Homepage.vue - was successful",
            response,
          );
          if (!response.data.hasOwnProperty('Picture')) {
            // window.EventBus.fire('triggerGenericErrorDialog', 'W_GED_001');
            return;
          }
          if (!response.data.hasOwnProperty('Description')) {
            // window.EventBus.fire('triggerGenericErrorDialog', 'W_GED_002');
            return;
          }
          if (!response.data.hasOwnProperty('Description')) {
            // window.EventBus.fire('triggerGenericErrorDialog', 'W_GED_003');
            return;
          }
          if (_.isEmpty(this.$store.getters.getUserCalendarCache)) {
            this.eventData = response.data;
          }
          this.eventPicture = response.data.Picture;
          this.eventData.Picture = data.picture;
          this.eventDescription = response.data.Description;
          this.order.EventId = response.data.EventId;
          if (showBookDialog) {
            this.showEvent(data, key);
          }
        },
        (error) => {
          console.log(
            "The call 'getEventDetailsV2' on - Homepage.vue - was not successful",
            error,
          );
          // window.EventBus.fire('triggerGenericErrorDialog', 'W_GED_004');
        },
        'getEventDetailsV2',
        Number(data.EventId),
        payload,
        600000,
        false,
      );
    },
    getCalendar(recievedStartDate, recievedEndDate, fromHomepage, dontShowError) {
      let userLanguage = this._userLanguage;
      let object = '';
      let payload = {};
      // this function will get the calendar for a specific partner or account
      if (this.$store.getters['auth/userName'] == '') {
        if (this.$store.getters.getSavePartnerId !== '') {
          object = `${this.$store.getters.getCurrentAccountId
          }_UG_${
            this.$store.getters.getSavePartnerId}`;
        } else {
          object = this.$store.getters.getCurrentAccountId;
        }
        payload = {
          StartDate: recievedStartDate,
          EndDate: recievedEndDate,
          LanguageTagId: Number(userLanguage),
        };
      } else {
        object = this.$store.getters['auth/userName'];

        if (Number(userLanguage) == null || userLanguage == undefined) {
          userLanguage = Number(13);
        }
        payload = {
          Runtime: true,
          StartDate: recievedStartDate,
          EndDate: recievedEndDate,
          LanguageTagId: Number(userLanguage),
        };
      }
      dssRequest.doRequest(
        (response) => {
          console.log(
            "The call for 'getCalendar' on - Homepage.vue - was successful",
            response,
          );
          if (!response.data.hasOwnProperty('Calendar')) {
            // window.EventBus.fire('triggerGenericErrorDialog', 'CALENDAR_NO_ITEMS');
            return;
          }
          if (_.isEmpty(response.data.Calendar)) {
            if (!dontShowError) {
              // window.EventBus.fire('triggerGenericErrorDialog', 'CALENDAR_NO_ITEMS');
            }
            return;
          }
          if (fromHomepage) {
            this.dontShowCalendar = false;
            setTimeout(() => {
              this.scrollMeTo('homepageCalendar');
            }, 500);
          }

          this.$store.commit('setCalendarIsEmpty', false);
          const calendarItems = response.data;
          // saving pictures to calendar items
          for (const [index, item] of Object.entries(calendarItems.Calendar)) {
            for (const [innerIndex, innerItem] of Object.entries(item)) {
              innerItem.Picture = calendarItems.Pictures[innerItem.PictureId];
              innerItem.EventDate = index;
            }
          }
          // to sort the calendar
          let ordered = {};
          const object = {};
          Object.keys(calendarItems.Calendar)
            .sort((a, b) => dateConverter(a) - dateConverter(b))
            .forEach((key) => {
              ordered[key] = calendarItems.Calendar[key];
            });
          for (const [key, value] of Object.entries(ordered)) {
            const array = [];
            for (const innerValue of Object.values(value)) {
              array.push(innerValue);
              object[key] = array;
            }
            for (const [innerKeyTwo, innerValueTwo] of Object.entries(
              object,
            )) {
              innerValueTwo.sort(compare);
            }
          }
          function compare(a, b) {
            const bandA = a.StartTime;
            const bandB = b.StartTime;

            let comparison = 0;
            if (bandA > bandB) {
              comparison = 1;
            } else if (bandA < bandB) {
              comparison = -1;
            }
            return comparison;
          }
          ordered = object;

          /* Convert DD/MM/YY to date object */
          function dateConverter(date) {
            const dateParts = date.split('-');
            const dateObject = new Date(
              +dateParts[2],
              dateParts[1] - 1,
              +dateParts[0],
            );
            return dateObject;
          }
          this.createCalendarArrayOfItems(ordered);
          this.recountPage();
        },
        (error) => {
          console.log(
            "The call for 'getCalendar' on - Homepage.vue - was not successful",
            error,
          );
          // window.EventBus.fire('triggerGenericErrorDialog', 'W_GC_001');
        },
        'getCalendar',
        object,
        payload,
        600000,
        false,
      );
    },
    getTourActivities(eventId) {
      const payload = {
        EventId: Number(eventId),
      };
      dssRequest.doRequest(
        (response) => {
          console.log(
            "The call 'getTourActivities' on - Homepage.vue - was successful",
            response,
          );
          if (!response.data.hasOwnProperty('TourActivities')) {
            // window.EventBus.fire('triggerGenericErrorDialog', 'W_GTA_001');
            return;
          }
          const filterObject = (obj, filter, filterValue) => Object.keys(obj).reduce(
            (acc, val) => (obj[val][filter] !== filterValue
              ? acc
              : {
                ...acc,
                [val]: obj[val],
              }),
            {},
          );
          const tourActivities = response.data.TourActivities;
          let tourActivitiesWithoutRelays = filterObject(
            tourActivities,
            'Type',
            'Standard',
          );
          tourActivitiesWithoutRelays = Object.keys(
            tourActivitiesWithoutRelays,
          ).map((key) => tourActivitiesWithoutRelays[key]);
          this.updateTourActivitiesPosition(tourActivitiesWithoutRelays);

          let relaysWithoutActivities = filterObject(
            tourActivities,
            'Type',
            'Relay',
          );
          relaysWithoutActivities = Object.keys(relaysWithoutActivities).map(
            (key) => relaysWithoutActivities[key],
          );
          this.setTourAspects(relaysWithoutActivities);
        },
        (error) => {
          console.log(
            "The call 'getTourActivities' on - Homepage.vue - was not successful",
            error,
          );
          // window.EventBus.fire('triggerGenericErrorDialog', 'W_GTA_001');
        },
        'getTourActivities',
        appConfig.dss.eventAdminMng,
        payload,
        600000,
        false,
      );
    },
    getThemesFromServer() {
      console.log("Lorenzo this.$store.getters.getThemes", this.$store.getters.getThemes);
      // This is to replace getEvents when the Homepage is loaded to reduce the data size
      if (!_.isEmpty(this.$store.getters.getThemes) && this.languageChanged !== true) {
        // if the themes have already been set in the cache, do not call the getEvents function again
        this.themes = this.$store.getters.getThemes;
        this.themeSelected = this.themes[0];
        if (this.themeSelected.Children.length === 0) this.noChildren = true;
        setTimeout(() => {
          this.updateListPositions(this.themeSelected);
          setTimeout(() => {
            this.carouselSelectChanged(this.themeSelected);
          }, 10);
        }, 10);
        this.showCalendar = true;
        return;
      }

      let userLanguage = 0;
      if (this.$store.getters.getUserLanguage !== '') {
        userLanguage = this.$store.getters.getUserLanguage;
      }
      const payload = {
        LanguageTagId: Number(userLanguage),
      };
      dssRequest.doRequest(
        (response) => {
          console.log("The call 'getThemes' on - Homepage.vue - was successful", response);
          if (!response.data.hasOwnProperty('Events')) {
            // window.EventBus.fire('triggerGenericErrorDialog', 'W_GT_001');
            return;
          }
          this.themes = [];
          if (Object.keys(response.data.Events).length > 1) {
            for (const [key, value] of Object.entries(response.data.Events)) {
              console.log("Lorenzo value", value);
              this.themes.push(value);
            }
            this.themes.forEach((item, index) => {
              if (
                item.Picture === null
                  || item.Picture === undefined
                  || item.Picture === ''
              ) {
                item.Picture = this.defaultImage;
              }
              item.ChildrenLoaded = false;
              // item.Tags = item.Tags.split(",");
              const recievedChildren = [];
              for (const [key, value] of Object.entries(item.Children)) {
                recievedChildren.push(value);
                if (
                  this.$store.getters.getCurrentEventId !== null
                    || this.$store.getters.getCurrentEventId !== undefined
                ) {
                  if (key == this.$store.getters.getCurrentEventId) {
                    this.clientTheme = index;
                    setTimeout(() => {
                      this.clientEvent = value.eventIndex;
                    }, 300);
                  }
                }
              }
              console.log("Lorenzo recievedChildren", recievedChildren);
              recievedChildren.forEach((item, index) => {
                item.eventIndex = index;
              });
              item.Children = recievedChildren;
              this.themes[index] = item;
            });
            const newArray = [];
            for (const [index, item] of Object.entries(this.themes)) {
              newArray.push(item);
            }
            function compare(a, b) {
              if (a.EventRanking > b.EventRanking) {
                return -1;
              }
              if (a.EventRanking < b.EventRanking) {
                return 1;
              }
              return 0;
            }

            newArray.sort(compare);
            this.themes = newArray;
            this.$store.commit('setThemes', this.themes);
            this.themeSelected = this.themes[0];
            if (this.themeSelected.Children.length === 0) this.noChildren = true;
            setTimeout(() => {
              this.updateListPositions(this.themeSelected);
              setTimeout(() => {
                this.carouselSelectChanged(this.themeSelected);
              }, 10);
            }, 10);
          }
          this.showCalendar = true;
        },
        (error) => {
          console.log("The call 'getThemes' on - Homepage.vue - was not successful", error);
          // window.EventBus.fire('triggerGenericErrorDialog', 'W_GT_001');
        },
        'getThemes',
        'LocationsNode_ESE',
        payload,
        600000,
        false,
      );
    },
    getChildrenEvents(parentEventId) {
      this.parentEventId = parentEventId;
      // This function will be called when 'View Activities' is triggered on the Homepage
      let userLanguage = 13;
      if (this.$store.getters.getUserLanguage !== '') {
        userLanguage = this.$store.getters.getUserLanguage;
      }

      const payload = {
        ParentEventId: Number(parentEventId),
        LanguageTagId: Number(userLanguage),
      };

      dssRequest.doRequest(
        (response) => {
          console.log("The call 'getChildrenEventsV2' on - Homepage.vue - was successful", response);
          if (!response.data.hasOwnProperty('Children')) {
            // window.EventBus.fire(' triggerGenericErrorDialog', 'W_GCE_001');
            return;
          }
          this.selectedTheme.ChildrenLoaded = true;
          const receivedChildren = [];
          for (const [key, value] of Object.entries(response.data.Children)) {
            value.BackgroundColor = '';
            receivedChildren.push(value);
          }
          receivedChildren.forEach((item, index) => {
            item.eventIndex = index;
          });
          this.selectedTheme.Children = [];
          this.selectedTheme.Children = receivedChildren;
          this.getFavourites();
          this.$store.commit('setEventSave', Number(parentEventId));
        },
        (error) => {
          console.log("The call 'getChildrenEventsV2' on - Homepage.vue - was not successful", error);
          // window.EventBus.fire('triggerGenericErrorDialog', 'W_GCE_001');
        },
        'getChildrenEventsV2',
        appConfig.dss.eventAdminMng,
        payload,
        600000,
        false,
      );
    },
    getFavourites() {
      if (this.$store.getters['auth/userName'] === '') return;
      const payload = {
        Runtime: true,
      };
      dssRequest.doRequest(
        (response) => {
          console.log("the call for 'getFavourites' on - Homepage.vue - was successful", response);
          if (!response.data.hasOwnProperty('Favourites')) {
            // window.EventBus.fire('triggerGenericErrorDialog', 'W_GF_001');
            return;
          }
          this.$store.commit('setListOfFavourites', response.data.Favourites);
          if (this.selectedTheme.hasOwnProperty('Children')) {
            this.selectedTheme.Children.forEach((item) => {
              item.Favourite = false;
              for (const [key, value] of Object.entries(
                response.data.Favourites,
              )) {
                if (item.EventId == value.EventId) {
                  item.Favourite = true;
                }
              }
            });
          }

          if (this.selectedLocation.hasOwnProperty('events')) {
            this.selectedLocation.events.forEach((item) => {
              item.Favourite = false;
              for (const [key, value] of Object.entries(
                response.data.Favourites,
              )) {
                if (item.EventId == value.EventId) {
                  item.Favourite = true;
                }
              }
            });
          }
        },
        (error) => {
          console.log("the call for 'getFavourites' on - Homepage.vue - was not successful", error);
          // window.EventBus.fire('triggerGenericErrorDialog', 'W_GF_001');
        },
        'getFavourites',
        this.$store.getters['auth/userName'],
        payload,
        600000,
        false,
      );
    },
    toggleFavourite(item) {
      const userId = this.$store.getters['auth/userName'];
      if (userId === '') {
        // User not logged in, go to login page
        this.goTo('Login');
        // this.$store.commit("setSaveFavourite", item.EventId);
      } else {
        this.seeTheListOfEvents = false;
        let functionCall = '';
        if (item.Favourite) {
          functionCall = 'deleteFavourite';
        } else {
          functionCall = 'addFavourite';
        }

        item.Favourite = !item.Favourite;
        this.seeTheListOfEvents = true;

        const payload = {
          EventId: Number(item.EventId),
        };
        dssRequest.doRequest(
          (response) => {
            console.log(
              `the call for ${functionCall} on - Homepage.vue - was successful`,
              response,
            );
            // this.$store.commit("setSaveFavourite", {});
          },
          (error) => {
            console.log(
              `the call for ${functionCall} on - Homepage.vue - was not successful`,
              error,
            );
            // window.EventBus.fire('triggerGenericErrorDialog', 'W_ADF_001');
          },
          functionCall,
          this.$store.getters['auth/userName'],
          payload,
          600000,
          false,
        );
      }
    },
    showEventsOfLocation(locationData) {
      console.log(locationData, 'benjaiminnnnnlocationnn');
      const payload = {
        LocationId: locationData.locationId,
        PartnerId: Number(this.$store.getters['auth/partnerId']),
        LanguageTagId: Number(this.$store.getters.getUserLanguage),
      };
      dssRequest.doRequest(
        (response) => {
          console.log(
            "The call 'getEventsForLocation' on - Homepage.vue - was successful",
            response,
          );
          if (!response.data.hasOwnProperty('Events')) {
            // window.EventBus.fire('triggerGenericErrorDialog', 'W_GEFL_001');
            return;
          }
          this.selectedLocation.name = locationData.name;
          this.selectedLocation.description = locationData.description;
          this.selectedLocation.events = response.data.Events;
          // ToDo When weijun deploys then uncomment

          // Only show list of Standard events for the location on the map
          const filterObject = (obj, filter, filterValue) => Object.keys(obj).reduce(
            (acc, val) => (obj[val][filter] !== filterValue
              ? acc
              : {
                ...acc,
                [val]: obj[val],
              }),
            {},
          );
            // this.selectedLocation.events = filterObject(
            //   this.selectedLocation.events,
            //   "Type",
            //   "Standard"
            // );

          this.selectedLocation.events = Object.keys(
            this.selectedLocation.events,
          ).map((key) => this.selectedLocation.events[key]);
          this.$store.commit('setActivitiesForLocation', this.selectedLocation.events);

          this.getFavourites();
        },
        (error) => {
          console.log(
            "The call 'getEventsForLocation' on - Homepage.vue - was not successful",
            error,
          );
          // window.EventBus.fire('triggerGenericErrorDialog', 'W_GEFL_001');
        },
        'getEventsForLocation',
        appConfig.dss.eventAdminMng,
        payload,
        600000,
        false,
      );
    },
    getLocationDetails() {
      // const payload = {
      // };
      // dssRequest.doRequest(
      //   (response) => {
      //     console.log(
      //       "the call for 'getLocationDetails' which is called on the main location on - Homepage.vue - was successful",
      //       response,
      //     );
      //     // window.EventBus.fire("updateCenterPoint", focusCoordinates);
      //   },
      //   (error) => {
      //     console.log(
      //       'the call for getLocationDetails on Main location was not successful',
      //       error,
      //     );
      //     window.EventBus.fire('triggerGenericErrorDialog', 'W_GLD_001');
      //   },
      //   'getLocationDetails',
      //   this.$store.getters.getAccountInfo.LocationId,
      //   payload,
      //   600000,
      //   false,
      // );
      console.log("Benjamin commented out call get location data");

    },
    // getEvents() {
    //   // Method to get all the themes for current account
    //   if (
    //     !_.isEmpty(
    //       this.$store.getters.getThemes && this.languageChanged !== true
    //     )
    //   ) {
    //     // if the themes have already been set in the cache, do not call the getEvents function again
    //     this.themes = this.$store.getters.getThemes;
    //     this.themeSelected = this.themes[0];
    //     if (this.themeSelected.Children.length == 0) this.noChildren = true;
    //     setTimeout(() => {
    //       this.updateListPositions(this.themeSelected);
    //       setTimeout(() => {
    //         this.carouselSelectChanged(this.themeSelected);
    //       }, 10);
    //     }, 10);
    //     this.showCalendar = true;
    //     return;
    //   }
    //   let userLanguage = 0;
    //   if (this.$store.getters.getUserLanguage !== "") {
    //     userLanguage = this.$store.getters.getUserLanguage;
    //   }
    //   const payload = {
    //     LanguageTagId: Number(userLanguage)
    //   };
    //   dssRequest.doRequest(
    //     response => {
    //       console.log("The call 'getEventsV2' on - Homepage.vue - was successful", response);
    //       if (!response.data.hasOwnProperty('Events')) {
    //         return;
    //       }
    //       this.themes = [];
    //       if (Object.keys(response.data.Events).length > 1) {
    //         for (let [key, value] of Object.entries(response.data.Events)) {
    //           value.EventId = key;
    //           this.themes.push(value);
    //         }
    //         this.themes.forEach((item, index) => {
    //           if (
    //             item.Picture == null ||
    //             item.Picture == undefined ||
    //             item.Picture == ""
    //           ) {
    //             item.Picture = this.defaultImage;
    //           }
    //           // item.Tags = item.Tags.split(",");
    //           const recievedChildren = [];
    //           for (const [key, value] of Object.entries(item.Children)) {
    //             value.EventId = key;
    //             value.BackgroundColor = "";
    //             recievedChildren.push(value);
    //             if (
    //               this.$store.getters.getCurrentEventId !== null ||
    //               this.$store.getters.getCurrentEventId !== undefined
    //             ) {
    //               if (key == this.$store.getters.getCurrentEventId) {
    //                 this.clientTheme = index;
    //                 setTimeout(() => {
    //                   this.clientEvent = value.eventIndex;
    //                 }, 300);
    //               }
    //             }
    //           }
    //           recievedChildren.forEach((item, index) => {
    //             item.eventIndex = index;
    //           });
    //           item.Children = recievedChildren;
    //           this.themes[index] = item;
    //         });
    //         let newArray = [];
    //         for (let [index, item] of Object.entries(this.themes)) {
    //           newArray.push(item);
    //         }
    //         function compare(a, b) {
    //           if (a.EventRanking > b.EventRanking) {
    //             return -1;
    //           }
    //           if (a.EventRanking < b.EventRanking) {
    //             return 1;
    //           }
    //           return 0;
    //         }
    //
    //         newArray.sort(compare);
    //         this.themes = newArray;
    //         this.$store.commit("setThemes", this.themes);
    //         this.themeSelected = this.themes[0];
    //         // if (!_.isEmpty(this.$store.getters.getSaveFavourite)) {
    //         //   this.toggleFavourite(this.$store.getters.getSaveFavourite);
    //         // }
    //
    //         if (this.themeSelected.Children.length == 0) this.noChildren = true;
    //         setTimeout(() => {
    //           this.updateListPositions(this.themeSelected);
    //           setTimeout(() => {
    //             this.carouselSelectChanged(this.themeSelected);
    //           }, 10);
    //         }, 10);
    //       }
    //       this.showCalendar = true;
    //     },
    //     error => {
    //       console.log("The call 'getEventsV2' on - Homepage.vue - was not successful", error);
    //     },
    //     "getEventsV2",
    //     appConfig.dss.eventAdminMng,
    //     payload,
    //     600000,
    //     false
    //   );
    // },
    // appTitle: '',
    // appDescription: '',
    getTextForAPP() {
      if (this.$store.getters.getUserLanguage == 13) {
        this.appTitle = this.$store.getters.getCustomerPreferences.app_title_english;
        this.appDescription = this.$store.getters.getCustomerPreferences.app_description_english;
      } else if (this.$store.getters.getUserLanguage == 14) {
        this.appTitle = this.$store.getters.getCustomerPreferences.app_title_dutch;
        this.appDescription = this.$store.getters.getCustomerPreferences.app_description_dutch;
      } else if (this.$store.getters.getUserLanguage == 17) {
        this.appTitle = this.$store.getters.getCustomerPreferences.app_title_german;
        this.appDescription = this.$store.getters.getCustomerPreferences.app_description_german;
      }
    },
    hideTheListOfEvents() {
      window.EventBus.fire('fireScrollMeTo', 'homepageThemes');
      this.seeTheListOfEvents = false;
    },
    checkForDates2() {
      if (this.computedDateFormattedSecondStartDate != null && this.computedDateFormattedSecondEndDate != null) {
        if (this.computedDateFormattedSecondStartDate > this.computedDateFormattedSecondEndDate) {
          this.searchButton2 = true;
        } else {
          this.searchButton2 = false;
        }
      } else {
        this.searchButton2 = true;
      }
    },
    cancelActivationDialog() {
      this.activationDialog = false;
      this.$store.commit('setUserActivatedSuccessfull', false);
    },
    checkForDates() {
      if (this.computedDateFormattedStartDate != null && this.computedDateFormattedEndDate != null) {
        const startDate = this.computedDateFormattedStartDate.split('-').reverse().join('');
        const endDate = this.computedDateFormattedEndDate.split('-').reverse().join('');
        if (startDate > endDate) {
          this.searchButton = true;
        } else {
          this.searchButton = false;
        }
      } else {
        this.searchButton = true;
      }
    },
    createPartner() {
      window.EventBus.fire('goToCreatePartner', {});
    },
    goToActvityDetailScreen(eventData) {
      console.log("Lorenzo eventData", eventData);
      if (eventData.hasOwnProperty('EventDate')) {
        this.$store.commit('setSelectedDate', eventData.EventDate);
      }
      this.$store.commit('setChosenEvent', eventData.EventId);
      this.goTo('ActivityDetailScreen', { event_id: eventData.EventId });
    },
    Get(url) {
      const Httpreq = new XMLHttpRequest(); // a new request

      Httpreq.open('GET', url, false);
      Httpreq.send(null);
      return Httpreq.responseText;
    },
    getEventsForThisTheme(eventId) {
      for (let i = 0; i < this.themes.length; i++) {
        if (this.themes[i].EventId == eventId) {
          this.selectedTheme = this.themes[i];
          this.$store.commit('setSelectedTheme', this.selectedTheme);
          this.seeTheListOfEvents = true;
          setTimeout(() => {
            this.scrollMeTo('homepageEvents');
          }, 1);
        }
      }
      if (!this.seeTheListOfEvents) return;
      // If children events are already loaded, do not load again; otherwise, load children events from server
      if (this.selectedTheme.ChildrenLoaded) this.getFavourites();
      else this.getChildrenEvents(eventId);
    },
    getNextWeekFromToday() {
      // This function is called to return the week after today for getCalendar
      const toTwoDigits = (num) => (num < 10 ? `0${num}` : num);
      const today = new Date();
      today.setDate(today.getDate() + 7);
      const year = today.getFullYear();
      const month = toTwoDigits(today.getMonth() + 1);
      const day = toTwoDigits(today.getDate());
      return `${day}-${month}-${year}`;
    },
    getNextMonthFromToday() {
      // This function is called to return the week after today for getCalendar
      const toTwoDigits = (num) => (num < 10 ? `0${num}` : num);
      const today = new Date();
      today.setDate(today.getDate() + 30);
      const year = today.getFullYear();
      const month = toTwoDigits(today.getMonth() + 1);
      const day = toTwoDigits(today.getDate());
      return `${day}-${month}-${year}`;
    },
    getCurrentDate() {
      // this function is called to get the current day to call the funtion getCalendar()
      const toTwoDigits = (num) => (num < 10 ? `0${num}` : num);
      const today = new Date();

      const year = today.getFullYear();
      const month = toTwoDigits(today.getMonth() + 1);
      const day = toTwoDigits(today.getDate());
      return `${day}-${month}-${year}`;
    },
    getEventsListForTheme() {
      clearInterval(this.slideShow);
    },
    retrieveNewInfoAfterLanguageChange() {
      setTimeout(() => {
        if (
          this.$store.getters.getCurrentEventId !== null
            && this.$store.getters.getCurrentEventId !== undefined
            && this.$store.getters.getCurrentEventId !== ''
        ) {
          this.storeCustomerEnv();
        } else {
          this.animationCircleEnterClass = 'bounceInUp';
          this.animationCircleLeaveClass = 'bounceOutUp';

          this.btnCarouselDisable = true;

          this.showDiscTags = false;
          this.showMidCircle = false;
          this.showCircle = false;

          setTimeout(() => {
            if (this.languageChanged === true) {
              this.getThemesFromServer();
              this.getCalendar(this.getCurrentDate(), this.getNextWeekFromToday(), false, true);
              if (this.seeTheListOfEvents && this.parentEventId !== '') {
                this.getChildrenEvents(this.parentEventId);
              }
            }
          }, 10);

          setTimeout(() => {
            this.showActivity = false;
            this.showDiscTags = true;
            this.showMidCircle = true;
            this.showCircle = true;
            this.btnCarouselDisable = false;
          }, 400 + 15 * 40);
        }
      }, 10);
    },
    onResize() {
      this.windowSize = { x: window.innerWidth, y: window.innerHeight };
      this.carouselHeight = 8.1 * window.innerHeight;
    },
    saveNewScrollPosition() {
      this.scrollPos = document.documentElement.scrollTop;
      this.$store.commit('setCurrentScrollPos', this.scrollPos);
    },
    setCardName() {
      // Set the Name of the Theme of the Activity in the mid-circle
      if (!this.showActivity && !this.childrensOpened) {
        if (this.themeSelected.EventTranslationName !== '') {
          return this.themeSelected.EventTranslationName;
        }
        return this.themeSelected.Name;
      }
      if (this.showActivity && !this.childrensOpened) {
        if (this.activitySelected.EventTranslationName !== '') {
          return this.activitySelected.EventTranslationName;
        }
        return this.activitySelected.Name;
      }
      if (
        this.selectedChildFromActivity.hasOwnProperty(
          'EventTranslationName',
        )
              && this.selectedChildFromActivity.EventTranslationName !== ''
      ) {
        return this.selectedChildFromActivity.EventTranslationName;
      }
      return this.selectedChildFromActivity.Name;
    },
    // shows event for custum event url
    storeCustomerEnv() {
      // this.getEvents();
      this.getThemesFromServer();

      this.customerUrlActive = true;
      setTimeout(() => {
        let themeActive = false;
        this.themes.forEach((e) => {
          if (e.EventId == this.$store.getters.getCurrentEventId) {
            themeActive = true;
            this.themeSelected = e;
          }
        });
        if (themeActive) {
          this.carouselSelectChanged(this.themeSelected);
          this.updateListPositions(this.themeSelected);
        } else {
          this.getEventDetails(
            this.themes[this.clientTheme].Children[this.clientEvent],
          );
        }
      }, 1000);
      setTimeout(() => {
        this.showMidCircle = true;
        this.showDiscTags = true;
        this.showCircle = true;
      }, 1700);
    },
    setBackgroundImageForAccount() {
      return this.$store.getters.getBackGroundImage;
    },
    setBackgroundLazyImage(){
      return this.themeSelected.Picture;
    },
    setBackgroundImage() {
      if (this.showActivity) {
        if (!this.childrensOpened) {
          if (
            this.activitySelected.Picture == null
              || this.activitySelected.Picture == undefined
              || this.activitySelected.Picture == ''
          ) {
            return this.defaultImage;
          }
          return this.activitySelected.Picture;
        } if (this.childrensOpened) {
          console.log(
            'EVERY STEPS',
            this.showActivity,
            this.childrensOpened,
            this.selectedChildFromActivity,
          );
          if (
            this.selectedChildFromActivity.Picture == null
              || this.selectedChildFromActivity.Picture == undefined
              || this.selectedChildFromActivity.Picture == ''
          ) {
            return this.defaultImage;
          }
          return this.selectedChildFromActivity.Picture;
        }
      }
      return this.themeSelected.PictureUrl;
    },
    updateListPositions(data) {
      // Gives position to Theme square on the banner in the homepage
      const angleSteps = 360 / data.Children.length;
      data.Children.forEach((item, element) => {
        const angle = element * angleSteps;
        const distance = 170;
        const x = (distance + 0.25 * item.widthSize)
            * Math.cos(angle * (Math.PI / 180));
        const y = (distance / 2 + 0.25 * item.widthSize)
            * Math.sin(angle * (Math.PI / 180));
        item.styleLeft = 175 + x;
        item.styleTop = 85 + y;
      });
    },

    updateTourActivitiesPosition(tourActivities) {
      const primaryRgbColor = this.hexToRgb(this.$vuetify.theme.primary);
      const secondaryRgbColor = this.hexToRgb(this.$vuetify.theme.secondary);
      const primaryRed = primaryRgbColor.r;
      const primaryGreen = primaryRgbColor.g;
      const primaryBlue = primaryRgbColor.b;
      const secondaryRed = secondaryRgbColor.r;
      const secondaryGreen = secondaryRgbColor.g;
      const secondaryBlue = secondaryRgbColor.b;
      const circlePosition = [
        [240, -180],
        [410, -70],
        [475, 120],
        [410, 310],
        [-235, 310],
        [-290, 120],
        [-235, -70],
        [-65, -180],
      ];
      if (this.mobilePhoneActive !== true) {
        let percent = 0;
        const markers = [];
        this.circleQuantity = tourActivities.length;
        this.showCircle = false;
        this.showMarkerLetter = true;
        if (tourActivities.length > 0) {
          const childrenLength = tourActivities.length;
          percent = 1 / (childrenLength / 3);
          for (let i = 0; i < childrenLength; i++) {
            if (childrenLength <= 8) {
              tourActivities[i].left = circlePosition[i][0];
              tourActivities[i].top = circlePosition[i][1];
            }
            const j = i / 3;
            // // linear interpilation of r.g.b.
            const resultRed = (
              primaryRed
                + percent * j * (secondaryRed - primaryRed)
            ).toFixed(0);
            const resultGreen = (
              primaryGreen
                + percent * j * (secondaryGreen - primaryGreen)
            ).toFixed(0);
            const resultBlue = (
              primaryBlue
                + percent * j * (secondaryBlue - primaryBlue)
            ).toFixed(0);
            const convertedRed = this.rgbToHex(resultRed);
            const convertedGreen = this.rgbToHex(resultGreen);
            const convertedBlue = this.rgbToHex(resultBlue);
            tourActivities[i].BackgroundColor = `#${convertedRed}${convertedGreen}${convertedBlue}`;
            tourActivities[i].widthSize = 170;
            tourActivities[i].heightSize = 170;
            markers.push({
              lat: tourActivities[i].Latitude,
              lng: tourActivities[i].Longitude,
              color: `#${convertedRed}${convertedGreen}${convertedBlue}`,
            });
          }
          setTimeout(() => {
            window.EventBus.fire('addMarkers', markers);
          }, 700);
        }
      }
      setTimeout(() => {
        if (tourActivities.length <= 8) {
          this.activitySelected.Children = tourActivities;
        } else {
          this.tourActivitiesList = tourActivities;
          this.tourActivitiesListToggle = true;
        }
      }, 10);
    },
    setTourAspects(relays) {
      const aspectIds = [];
      const allRoutes = this.$store.getters.getRoutes;
      const aspects = [];
      const polyline = [];

      for (let i = 0; i < relays.length; i++) {
        aspectIds.push(relays[i].Relay.AspectId);
      }
      for (let i = 0; i < aspectIds.length; i++) {
        aspects.push(_.pick(allRoutes, aspectIds[i]));
      }

      this.locationProps.params.location.polyline = polyline;

      window.EventBus.fire('generateTourPoints', { routeAspects: [aspects], disableChangeView: false });
    },
    selectTheme(item) {
      this.activityType = 'theme';
      this.showActivity = false;
      this.themeSelected = {};
      this.themeSelected = { ...item };
      if (
        this.themeSelected.Children.length == 0
          || _.isEmpty(this.themeSelected.Children)
      ) {
        this.noChildren = true;
      } else {
        this.noChildren = false;
        this.updateListPositions(this.themeSelected);
      }
    },
    selectActivity(item) {
      this.showActivity = true;
      this.activitySelected = {};
      this.activitySelected = { ...item };
      if (
        this.activitySelected.Children.length == 0
          || _.isEmpty(this.activitySelected.Children)
      ) {
        this.activityChildrensActive = false;
      } else {
        this.activityChildrensActive = true;
      }
    },
    focusOnMarkers(lat, lon) {
      const coordinate = [Number(lon), Number(lat)];
      window.EventBus.fire('showOnMap', coordinate);
    },
    selectChild(item) {
      this.showActivity = true;
      this.selectedChildFromActivity = {};
      this.selectedChildFromActivity = { ...item };
    },
    // used for the back button
    goBack() {
      if (this.showActivity && !this.childrensOpened) {
        this.animationCircleEnterClass = 'zoomIn';
        this.animationCircleLeaveClass = 'zoomOut';
        this.bookOneEvent = false;

        setTimeout(() => {
          this.showMarkerLetter = false;
          this.showMidCircle = false;
          this.showDiscTags = false;
          this.showCircle = false;
          this.childrensOpened = false;
        }, 10);

        setTimeout(() => {
          this.showActivity = false;
          this.activityChildrensActive = false;
          this.activitySelected = {};
          this.eventIndex = -1;
          this.selectTheme(this.themes[this.carouselIndex]);
        }, 300);

        setTimeout(() => {
          this.showCircle = true;
          this.showMidCircle = true;
          this.showDiscTags = true;
        }, 400);
      } else if (this.showActivity && this.childrensOpened) {
        this.show();
        this.childrensOpened = false;
        this.selectedChildFromActivity = {};
        this.selectActivity(this.activitySelected);
        this.updateListPositions(this.activitySelected);
      }
    },
    hexToRgb(hex) {
      // changes HEX code to RGB code
      const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
      return result
        ? {
          r: parseInt(result[1], 16),
          g: parseInt(result[2], 16),
          b: parseInt(result[3], 16),
        }
        : null;
    },
    rgbToHex(rgb) {
      // Changes RGB code to HEX code
      let hex = Number(rgb).toString(16);
      if (hex.length < 2) {
        hex = `0${hex}`;
      }
      return hex;
    },
    planTrip() {
      if (_.isEmpty(this.themeSelected)) {
        alert('Please choose a theme.');
      } else if (!_.isEmpty(this.activitySelected)) {
        this.$store.commit(
          'setThemeListEventId',
          this.activitySelected.EventId,
        );
        this.$router.push({
          name: 'Calendar',
          params: {
            type: 'u',
            account_id: this.$store.getters.getRegion,
            partner_id: this.activitySelected.PartnerId,
          },
        });
      } else {
        this.$store.commit('setTripFormChosenTheme', this.themeSelected);
        this.$store.commit('setTripFormGroupSize', 1);
        this.$store.commit('setWebStepId', 2);
        const userId = this.$store.getters['auth/userName'];
        if (this.$store.getters['auth/userName'] === '') {
          // User not logged in, go to login page
          this.goTo('Login');
        } else {
          // User already logged in, go to main event info page
          this.$router.push({
            name: 'MainEventInfo',
            params: {
              type: 'u',
            },
          });
        }
      }
    },
    goTo(page, params = 'component') {
      // Generic function to let the user move to other component
      this.$router.push({
        name: page,
        params,
      });
    },
    carouselLeftChanged() {
      clearInterval(this.slideShow);
      this.slideShow = setInterval(this.carouselRightChanged, 8000);
      // changes animations and loads data from left to right
      this.animationCircleEnterClass = 'bounceInLeft';
      this.animationCircleLeaveClass = 'bounceOutRight';

      this.btnCarouselDisable = true;
      setTimeout(() => {
        this.showMarkerLetter = false;
        this.showDiscTags = false;
        this.showMidCircle = false;
        this.showCircle = false;
      }, 10);

      if (!this.showActivity && !this.childrensOpened) {
        setTimeout(() => {
          this.themeSelected = {};
          if (this.carouselIndex == 0) {
            this.carouselIndex = this.themes.length;
          }
          this.carouselIndex -= 1;
          this.showActivity = false;
          this.selectTheme(this.themes[this.carouselIndex]);
          this.showDiscTags = true;
          this.showMidCircle = true;
          this.showCircle = true;
          this.btnCarouselDisable = false;
        }, 390 + this.circleQuantity * 40);
      } else if (this.showActivity && !this.childrensOpened) {
        if (this.eventIndex == 0) {
          this.eventIndex = this.themes[this.carouselIndex].Children.length;
        }
        this.eventIndex -= 1;
        this.getEventDetails(
          this.themes[this.carouselIndex].Children[this.eventIndex],
        );
        setTimeout(() => {
          this.showMidCircle = true;
          this.showDiscTags = true;
          this.showCircle = true;
          this.btnCarouselDisable = false;
        }, 390 + this.circleQuantity * 40);
      } else if (this.showActivity && this.childrensOpened) {
        if (this.childEventIndex == 0) {
          this.childEventIndex = this.activitySelected.Children.length;
        }
        this.childEventIndex -= 1;
        this.getEventDetails(this.activitySelected.Children[1]);
      }
    },

    carouselRightChanged() {
      clearInterval(this.slideShow);
      this.slideShow = setInterval(this.carouselRightChanged, 8000);
      // changes animations and loads data from right to left
      this.animationCircleEnterClass = 'bounceInRight';
      this.animationCircleLeaveClass = 'bounceOutLeft';
      this.btnCarouselDisable = true;
      setTimeout(() => {
        this.showDiscTags = false;
        this.showMidCircle = false;
        this.showCircle = false;
      }, 10);
      if (!this.showActivity && !this.childrensOpened) {
        setTimeout(() => {
          this.themeSelected = {};
          this.carouselIndex += 1;
          if (this.carouselIndex == this.themes.length) {
            this.carouselIndex = 0;
          }
          this.showActivity = false;
          this.selectTheme(this.themes[this.carouselIndex]);
          this.showDiscTags = true;
          this.showMidCircle = true;
          this.showCircle = true;
          this.btnCarouselDisable = false;
        }, 390 + this.circleQuantity * 40);
      } else if (this.showActivity && !this.childrensOpened) {
        this.eventIndex += 1;
        if (
          this.eventIndex == this.themes[this.carouselIndex].Children.length
        ) {
          this.eventIndex = 0;
        }
        this.getEventDetails(
          this.themes[this.carouselIndex].Children[this.eventIndex],
        );
        setTimeout(() => {
          this.showMidCircle = true;
          this.showDiscTags = true;
          this.showCircle = true;
          this.btnCarouselDisable = false;
        }, 390 + this.circleQuantity * 40);
      } else if (this.showActivity && this.childrensOpened) {
        console.log('^^^@1', this.childrensOpened);
        console.log('^^^^childrens from activity');
      }
    },

    carouselSelectChanged(card, index, i = null) {
      // changes animations and loads data from bottom to top
      this.animationCircleEnterClass = 'bounceInUp';
      this.animationCircleLeaveClass = 'bounceOutUp';

      this.btnCarouselDisable = true;
      setTimeout(() => {
        this.showDiscTags = false;
        this.showMidCircle = false;
        this.showCircle = false;
      }, 10);

      setTimeout(() => {
        if (i !== null) {
          this.carouselIndex = index * 6 + i;
        }
        this.themeSelected = {};
        this.showActivity = false;
        this.selectTheme(card);

        this.showDiscTags = true;
        this.showMidCircle = true;
        this.showCircle = true;
        this.btnCarouselDisable = false;
      }, 400 + this.circleQuantity * 40);
    },

    scrollMeTo(refName) {
      const element = this.$refs[refName];
      const height = element.offsetTop - 100;

      window.scrollTo({
        top: height,
        left: 0,
        behavior: 'smooth',
      });
    },
    selectPage(number) {
      this.recountPage();
    },
    nextPage() {
      this.recountPage();
    },
    previousPage() {
      this.recountPage();
    },
    createCalendarArrayOfItems(data) {
      this.calendarItems = [];
      // Adding the date to the events and saving the events in array calendarItems
      const recievedData = data;
      for (const [key, value] of Object.entries(recievedData)) {
        value.forEach((element, innerKey) => {
          if (!this.calendarItems.includes(key)) {
            this.calendarItems.push(key);
          }
          this.calendarItems.push(element);
        });
      }
      this.$store.commit('setCalendarOnHomePage', this.calendarItems);
    },
    recountPage() {
      this.nPages = Math.ceil(this.$store.getters.getCalendarOnHomePage.length / this.elementXpage);
      const start = (this.page - 1) * this.elementXpage;
      this.paginatedCalendar = [];
      this.paginatedCalendar = this.$store.getters.getCalendarOnHomePage.filter(
        (e, i) => i >= start && i < start + this.elementXpage,
      );
    },
    searchActivityWithSelectedDates(firstDate, secondDate) {
      // Searching in calendar with given dates
      this.onlyOnSearch = true;
      this.getCalendar(firstDate, secondDate, true);
    },
    formatDate(date) {
      if (!date) return null;

      const [year, month, day] = date.split('-');
      return `${day}-${month}-${year}`;
    },
    redirectToBookPage(data, date, boolean) {
      const object = { Data: data, Date: date, Boolean: boolean };
      this.$store.commit('setBookingData', object);
      if (this.$store.getters.getSavePartnerId !== '') {
        this.$router.push({
          name: 'Calendar',
          params: {
            type: 'u',
            account_id: this.$store.getters.getRegion,
            partner_id: Number(this.$store.getters.getSavePartnerId),
          },
        });
      } else {
        this.$router.push({
          name: 'Calendar',
          params: {
            type: 'u',
            account_id: this.$store.getters.getRegion,
          },
        });
      }
    },
    cycle(input) {
      if (input === 'back') {
        // Clicking backwards on the carousel
        this.slide = 0;
      } else {
        // Clicking forwards on the carousel
        this.slide = 1;
      }
    },
    goToPassport() {
      // Register/login first, than move to passport Page
      this.goTo('Login');
      this.$store.commit('setUserIsCreatingPassport', true);
    },
    initializeHomepageMap() {
      const homepageMap = this.$refs.homepageMap.map;
      homepageMap.deleteLayer('test');
      homepageMap._updateCenterPoint(this.$store.getters.getCenterPointForMap);
      const features = [];
      console.log("Brian allMarkers", this.allMarkers);

      this.allMarkers.forEach(marker => {
        if (marker.MainTag === '') marker.MainTag = 'POI';
        features.push(MapObject.createCategoryMarker({
          longitude: marker.Longitude,
          latitude: marker.Latitude,
          category: marker.MainTag,
          data: {locationId: marker.LocationId},
        }));

        features.push(MapObject.createPolyline(
          marker.Polyline,
          this.setPolylineColor(marker.DensityCategory),
          3,
        ));
      });
      const vectorSource = MapObject.createVectorSource(features);
      const vectorLayer = MapObject.createVectorLayer('test', vectorSource);
      vectorLayer.setZIndex(100);
      homepageMap.addLayerOnMap(vectorLayer);

      let select = new ol.interaction.Select({});
      homepageMap.map.addInteraction(select);
      // on click function
      const self = this;
      select.on('select', (evt) => {
        if (evt.target.getFeatures().a.length > 0) {
          let locationId = evt.target.getFeatures().a[0].N.data.locationId;
          select.getFeatures().clear();
          self.showLocationDetails(locationId);
        }
      });
    },
    showLocationDetails(locationId) {
      const payload = {
      };
      dssRequest.doRequest(
        (response) => {
          console.log(
            "the call for 'getLocationDetails' which is called on - Homepage.vue - was successful",
            response,
          );
          if (response.data.PartnerLevel <= 1) {
            window.EventBus.fire("showBottomPopup", response.data);
          } else {
            window.EventBus.fire("showSideBar", response.data);
          }
        },
        (error) => {
          console.log(
            "the call for 'getLocationDetails' which is called on - Homepage.vue - was successful",
            error,
          );
          // window.EventBus.fire('triggerGenericErrorDialog', 'W_GLD_001');
        },
        'getLocationDetails',
        locationId,
        payload,
        600000,
        false,
      );
    },
    checkIfImageExist(variable){
      // let image = new File('../assets/Destination-states/categories/' + variable + '.png');
      const fs = require('fs')

      const path = '../assets/Destination-states/categories/' + variable + '.png'

      try {
        if (fs.existsSync(path)) {
          console.log("Lorenzo image exists", );
        }
      } catch(err) {
        console.error(err)
      }
    },
    getLocations(filters = null) {
      const payload = {
        LanguageTagId: this.$store.getters.getUserLanguage,
        // Densities: [0, 1, 2, 3, 4],
        SortOn: 'Name',
      };
      if (filters !== null) payload.Categories = filters;
      dssRequest.doRequest(
        response => {
          console.log(
            'The call `getLocations` on - Homepage.vue - was successful',
            response,
          );
          if(response.data.hasOwnProperty('Filters')){
            if(_.isEmpty(this.$store.getters.getFiltersForMap)){
              this.$store.commit('setFiltersForMap', response.data.Filters.Categories)
            }
          }
          if (response.data.hasOwnProperty('CenterPoint')) {
            this.$store.commit('setCenterPointForMap', response.data.CenterPoint);
          }
          if (response.data.hasOwnProperty('Locations')) {
            let receivedMarkers = response.data.Locations;
            receivedMarkers.forEach( arrayElement => {
              let polyline = [];
              arrayElement.Polyline = arrayElement.Polyline.split(' ');
              arrayElement.Polyline.forEach( arrayMarker => {
                let correctPolylineElement = arrayMarker.split(',');
                correctPolylineElement[0] = Number(correctPolylineElement[0]);
                correctPolylineElement[1] = Number(correctPolylineElement[1]);
                polyline.push(correctPolylineElement);
              });
              arrayElement.Polyline = polyline;
            });
            this.allMarkers = [];
            this.allMarkers = receivedMarkers;
            if (filters === null) this.$store.commit('setNewLocationList', this.allMarkers);
          }
          if (!this.$store.getters.getMobilePhoneActive) {
            this.initializeHomepageMap();
          }
        },
        (error) => {
          console.log(
            'The call `getLocations` on - Homepage.vue - was not successful',
            error
          );
        },
        'getLocations',
        this.$store.getters.getCurrentAccountId + '_LSE',
        payload,
      );
    },
    setPolylineColor(state) {
      switch (state) {
        case 0:
          return '#A9A9A9';
        case 1:
          return '#009933';
        case 2:
          return '#ffff00';
        case 3:
          return '#ff8000';
        case 4:
          return '#ff0000';
        default:
          return '#A9A9A9';
      }
    },
  },
};
</script>

<style lang="scss" scoped>
  // Mobile phone styling
  .themeBackgroundMobile {
    overflow-x: auto;
    overflow-y: hidden;
    background: none;
    margin-top: 1.2em !important;
    margin-left: -3.4em;
    margin-right: -4em;
    margin-bottom: -2em;
  }

  .imageBlurMobile {
    height: 40em !important;
    width: 100%;
    margin-bottom: -65% !important;
    background-position: center !important;
    background-repeat: no-repeat !important;
    background-size: cover !important;
    position: absolute;
  }

  .carouselBtnMobile {
    margin-left: 3em;
    margin-right: 2em;
    margin-bottom: -25em;
    z-index: 200;
  }

  .rounded-card-event-selector-mobile {
    margin-right: 10em;
    margin-top: 2em;
  }

  .rounded-inner-card-mobile {
    margin-top: 18em;
    margin-left: 16em;
    width: 90%;
    height: 95%;
  }

  .avatarThemeMobile {
    background-color: #ffffff;
    margin-top: 8em !important;
    opacity: 0.9;
    border: 4px solid black;
    border-radius: 50%;
    padding: 2em;
    width: 15em;
    height: 15em;
    position: relative;
    margin: 0 auto;
    box-sizing: border-box;
    cursor: pointer;
  }

  .cardActivitiesPositionMobile {
    cursor: pointer;
    border-radius: 0.5em;
    color: black;
    opacity: 0.9 !important;
    min-width: 10em;
    font-size: 14px;
    z-index: 100;
  }

  .cardNamePositionMobile {
    cursor: pointer;
    border-radius: 0.5em;
    color: black;
    opacity: 1.2 !important;
    max-width: 70% !important;
    font-size: 25px;
    margin-top: -6.5em;
    z-index: 100;
  }

  .highlightsMobile {
    margin-left: 3em;
    margin-right: 3em;
  }

  .activitiesMobile {
    margin-left: 3em;
    margin-right: 3em;
  }

  .mapForHomepage {
    max-width: 80%;
    max-height: 100%;
    margin-left: 2em;
    margin-right: 2em;
    overflow-y: hidden;
  }

  // Non-mobile styling


  .imageBlur {
    height: 740px !important;
    width: 100%;
    margin-bottom: -65% !important;
    background-position: center !important;
    background-repeat: no-repeat !important;
    background-size: cover !important;
    position: absolute;
  }
  .rounded-card {
    border-radius: 10px;
  }
  .rounded-card-event-selector {
    margin-right: 10em;
    margin-top: 2em;
  }
  .rounded-inner-card {
    margin-top: 10em;
    margin-left: 10em;
    width: 90%;
    height: 75%;
  }
  #circle-list {
    background-color: #ffffff00 !important;
    border-radius: 50%;
    width: 340px;
    height: 340px;
    position: absolute;
    top: 20%;
    padding: 0;
    list-style: none;
    margin-left: -100px;
  }
  .backgroundHolder {
    cursor: pointer;
    position: absolute;
    display: block;
    width: 100%;
    height: 100%;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    border-radius: 50%;
  }
  .backgroundHolder:hover {
    transform: scale(1.1);
  }
  .planTripButton {
    z-index: 998;
    margin-right: 8%;
    margin-bottom: -17em;
    transform: scale(1.5);
  }

  .scrollbarInEvents {
    padding-bottom: 1em;
    border-radius: 10px;
    max-height: 17em;
    overflow-y: auto;
    overflow-x: hidden;
  }
  .planTripButton:hover {
    transform: scale(1.1);
  }
  .backButton {
    z-index: 999;
    margin-bottom: -8em;
  }
  .backButton:hover {
    transform: scale(1.1);
  }
  .avatarTheme {
    margin-top: 8em !important;
    /*border: 4px solid black;*/
    border-radius: 10px;
    opacity: 0.7;
    padding: 2em;
    width: 23em;
    height: 18em;
    position: relative;
    margin: 0 auto;
    box-sizing: border-box;
    cursor: pointer;
  }

  .avatar {
    margin-top: -12.7em;
    margin-left: -9em;
  }
  .cardNamePosition {
    cursor: pointer;
    border-radius: 0.5em;
    color: black;
    opacity: 1.2 !important;
    min-width: 10em;
    font-size: 25px;
    margin-top: -7em;
    margin-left: 1em;
    z-index: 100;
  }
  .cardActivitiesPosition {
    cursor: pointer;
    border-radius: 0.5em;
    color: black;
    opacity: 0.9 !important;
    min-width: 10em;
    font-size: 15px;
    margin-left: 1em;
    z-index: 100;
  }
  .carouselBtn {
    margin-bottom: -45%;
    z-index: 200;
  }
  .innerCardWithCircles {
    margin-top: -4em !important;
  }
  .screenMap {
    position: relative;
    -moz-border-radius: 50%;
    border-radius: 50%;
    overflow: hidden;
    margin-top: -12em !important;
  }
  .tourActivitiesList {
    max-height: 25em;
    position: relative;
    z-index: 99 !important;
    margin-top: -25em !important;
    margin-left: 35em;
    max-width: 30em;
    min-width: 22em !important;
  }
  .v-input__slot {
    -webkit-box-shadow: none !important;
    box-shadow: none !important;
  }
  .Alphabet {
    font-size: 25px !important;
  }
  .midCircle {
    background-color: #424242;
  }
  .slideshow {
    height: 700px;
  }
  .blokje {
    min-height: 600px;
    width: 80%;
    max-width: 1000px;
    margin: auto;
  }
  .themeCard {
    margin: 1em;
  }
  .themeImage {
    height: 19em;
    padding: 1em;
  }
  .formMET {
    height: 5em;
    background-color: lightgrey;
  }
  .mapForHomepage {
    max-width: 100%;
    max-height: 100%;
    margin-left: 2em;
    margin-right: 2em;
    overflow-y: hidden;
  }
  .mapForHomepageResponsive {
    max-width: 100%;
    max-height: 100%;
    margin-left: 5em;
    margin-right: 3em;
    overflow-y: hidden;
  }
  .calendarImage {
    border-radius: 10px !important;
    width: 13em !important;
    background-position: center center;
    background-size: cover;
  }
  .totalEvents {
    max-width: 25%;
    align-items: center;
    justify-content: center;
  }
  .buttonInCarouselDiv:hover {
    transform: scale(0.8);
  }
  .buttonInSearchActivityStroke:hover {
    transform: scale(0.8);
  }
  .datePickerHomePage {
    max-width: 100%;
    border: 1px solid black !important;
  }
  .datePickerStyling {
    max-width: 80%;
    margin-top: -1em;
    margin-bottom: 2.5em;
  }
  .iphoneAppPicture {
    transform: scale(0.7);
    margin-top: -6em;
  }
  .partnerDescriptions{
    min-height: 17em;
    width: 60em;
  }
  .PartnerImg{
    margin:1em;
    width: 7em;
    height: 7em;
  }
  .activityText {
    color: white;
    text-shadow: 0 1px 0 black;
  }
  .translationName {
    font-size: 3em;
  }
  .confirmLoadingDialog {
    border-radius: 1em !important;
  }
  .rounded-favourite-card {
    border-radius: 10px !important;
  }
  .surroundingFavourite {
    min-height: 600px;
    margin: auto;
  }
  .favouriteImage {
    min-height: 19em;
    max-height: 19em;
    padding: 1em;
  }
  .favouriteCard {
    margin: 1em;
    border-radius: 10px !important;
  }
  .suggestionsImage {
    border-radius: 10px;
    margin-top: 0.5em;
    margin-bottom: 0.5em;
    height: 90% !important;
    width: 90% !important;
  }
  .textWidth {
    max-width: 85% !important;
  }
  .userPhoto {
    margin-top: 1em;
    margin-bottom: 2em;
    border-radius: 10px !important;
    max-height: 35% !important;
    max-width: 35% !important;
  }
  .memberPhoto {
    margin-left: 10%;
    margin-bottom: -3%;
    max-height: 15em !important;
    max-width: 15em !important;
  }
  .innerPassport {
    margin: 2em;
    padding-bottom: 2em;
    opacity: 0.8;
    background-color: white !important;
  }
  .rightPassportPhoto {
    margin-top: -4em !important;
  }
  .midSection {
    margin-top: 4em;
  }
  .carouselBtn {
    margin-top: 20% !important;
  }
  .rounded-card-closed-passport {
    border-radius: 10px;
    max-width: 1000px !important;
    width: 66%;
    margin-top: 2em !important;
    height: 80% !important;
    padding: 5em 8em 4em 8em;
    /*margin-left: 4em !important;*/
    display: inline-block;
    margin: 1.5em;
  }
  .passportPhotoImg {
    margin-top: 1em;
    height: 35em;
    width: 22em;
  }
  .passportPhotoText {
    margin-top: 5em;
  }
  .createPassportBtn {
    margin-right: 2em !important;
    transform: scale(1.3);
  }
  .createPassportBtn:hover {
    transform: scale(1.1);
  }
  .titlePassportText {
    margin-bottom: -2em;
  }
  .memberPhotoInPassport {
    margin-left: 15%;
    margin-top: -1em;
    margin-bottom: 3%;
    max-height: 12em !important;
    max-width: 12em !important;
  }
  .progressBar {
    margin-top: -1em;
  }
  .textWidthPassport {
    max-width: 85% !important;
  }
  .suggestionsImagePassport {
    border-radius: 10px;
    margin-top: 0.5em;
    margin-bottom: 0.5em;
    height: 90% !important;
    width: 90% !important;
  }
  .scrollableVCard {
    height: 35em;
    overflow-x: hidden;
    overflow-y: auto;
  }
  .themeDescription {
    color: white;
  }
  .searchBarText {
    color: white;
  }
  .mapForHomepageMobile {
    width: 75%;
    margin-bottom: 5em;
    margin-left: -2em;
  }
  .middleInformation{

  }
  /* width */
  ::-webkit-scrollbar {
    width: 10px;
  }

  /* Track */
  ::-webkit-scrollbar-track {
    background: #CAC9CE;
  }

  /* Handle */
  ::-webkit-scrollbar-thumb {
    background: #0D749B;
  }

  /* Handle on hover */
  ::-webkit-scrollbar-thumb:hover {
    background: #555;
  }
  .v-card--reveal {
    padding: 1em;
    align-items: start;
    bottom: 0;
    opacity: 1;
    position: absolute;
    width: 100%;
    border-radius: 10px;
  }
  .dateTitle {
    margin: 0 !important;
    text-align: center;
    background-color: rgb(224,224,224);
  }
  .themeBackground {
    background: none;
    margin-top: 1.2em !important;
    margin-left: -3.4em;
    margin-right: -3.4em;
    margin-bottom: -2em;
    padding-bottom: 1em;
  }
</style>
